// 1.0 DEFINE CONST
const _document = $(document);
const _window = $(window);
const windowWidth = _window.width();
const windowHeight = _window.height();
const html = $('html');
const body = $('body');

const screenisCompact = 1200 >= windowWidth
  ? true : false;
const screenIsTablet = 900 >= windowWidth
  ? true : false;
const screenIsMobile = 600 >= windowWidth
  ? true : false;
const scrollOffset = 95 - 1;

// 2.0 TOOLS/UTILITIES

const scrollTo = (id) => {
  let scrollContainer = html;
  let scrollPosition = typeof id != 'number'
    ? id == 'window'
      ? windowHeight
      : $(id).length
        ? $(id).offset().top
        : 0
    : windowHeight * (id / 100);

  if (getComputedStyle(scrollContainer[0]).scrollBehavior === 'smooth') {
    scrollContainer.scrollTop(scrollPosition - scrollOffset);
  } else {
    scrollContainer.animate({
      scrollTop: scrollPosition - scrollOffset
    });
  }
}

const formatHandleize = (string) => {
  return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
}

const formatLeadingZero = (value) => {
  return (value < 10 ? '0' : '') + value;
}

const formatCommify = (value) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const formatMoney = (price) => {
  let updatedValue;
  if (theme.currency.iso_code === 'USD') {
    updatedValue = `${theme.currency.symbol}${price.toFixed(price % 1 !== 0 ? 2 : 0)}`;
  } else {
    updatedValue = `${theme.currency.symbol}${price.toFixed(price % 1 !== 0 ? 2 : 0)} ${theme.currency.iso_code}`;
  }

  return updatedValue;
}


const validateEmail = (email) => {
  let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

const validatePhone = (phone) => {
  let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(phone);
}

$.fn.extend({
  toggleText: function (a, b) {
    return this.text(this.text() == b ? a : b);
  }
});

const siteReadyTrigger = (punk, delay) => {
  document.addEventListener('readystatechange', event => {
    if (document.readyState == 'complete') {
      (delay) ? setTimeout(punk, delay) : punk();
    }
  });
}

const loadingBarTrigger = (stage) => {
  const loadingBar = $('#loading-bar');

  let action = (loadingBar.css('opacity') == 1 && stage != 'done')
    ? 'move' : stage

  switch (action) {
    case 'start':
      loadingBar.css('opacity', 1)
        .width(windowWidth * (Math.floor(Math.random() * 6) + 1) / 10);
      break;

    case 'move':
      loadingBar.css('opacity', 1)
        .width(loadingBar.width() * 1.15);
      break;

    case 'done':
      loadingBar.width(windowWidth);

      setTimeout(function () {
        loadingBar.css('opacity', 0);
      }, 300);

      setTimeout(function () {
        loadingBar.width(0);
      }, 600);
      break;
  }
}

// 3.0 PAGES/COMPONENTS

const initPageTransition = () => {
  let siteUrl = shopUrl.replace('www.', '').replace('http://', '').replace('https://', '');

  $('a[href]').each(function () {
    let _this = $(this);
    let href = _this.attr('href');

    if ((href.includes(siteUrl) || href.startsWith('/') || href.startsWith('#')) &&
      _this.attr('target') != '_blank' && !href.includes('mailto:')) {
      _this.attr('data-location', 'internal');

    } else {
      _this.attr('data-location', 'external')
    }
  });

  _document.on('click', 'a[href]', function (e) {
    let _this = $(this);
    let href = _this.attr('href');
    let hrefSplitHash = href.split('#');
    let windowHrefSplitHash = window.location.href.split('#');

    html.removeClass('mobile_menu_active minicart_active search_pane_active');

    // if hash origin url is current url
    if (href.startsWith('#') ||
      hrefSplitHash[0] == windowHrefSplitHash[0]) {
      e.preventDefault();

      // scroll to hash location
      scrollTo(`#${hrefSplitHash[1]}`);

    } else if (_this.attr('data-location') == 'internal' &&
      keyOnPress == false) {
      e.preventDefault();

      html.addClass('is_leaving');

      window.location.href = href;
    }
  });
}


const initPageAnimation = () => {
  const animationScroll = () => {
    const scrollTopOffsetAni = scrollTop + windowHeight * 0.85

    // get all anchor with top offset
    $('[data-ani-anchor]:not([data-ani-anchor="onload"])').each(function () {
      let _this = $(this);
      let _thisTop = parseInt(_this.attr('data-ani-top'));

      if (scrollTopOffsetAni > _thisTop &&
        !_this.hasClass('animate')) {
        _this.addClass('animate')

        _this.trigger('animate');
      }
    });
  }

  siteReadyTrigger(function () {
    $('[data-ani-anchor]').each(function () {
      let _this = $(this);

      // if animates on load, trigger animate immediately
      (_this.data('ani-anchor') == 'onload')
        ? _this.addClass('animate') : '';

      _this.attr('data-ani-top',
        Math.floor(_this.offset().top));
    });

    animationScroll();
    _window.scroll(animationScroll);
  }, 50);
}

const initHeader = () => {
  const header = $('#header');
  let headerFill = html.hasClass('header_fill')
    ? true : false;
  const $quickLinks = $('.section-mobile-quicklinks');
  if ($quickLinks.length > 0 && matchMedia('(max-width: 900px)').matches) {
    html.addClass('header_fill');
    headerFill = true;
  }

  const headerScroll = () => {
    if (scrollTop > 10 || headerFill == true) {
      if (!$(body).hasClass('template-blog-nightstand')) {
        html.addClass('header_fill')
      }
    } else {
      if (!html.hasClass('search_pane_active') && !html.hasClass('mobile_menu_active')) {
        html.removeClass('header_fill')
      }
    }
  }
  siteReadyTrigger(headerScroll);
  _window.on('scroll', headerScroll);

  if (location.pathname === '/') {
    _window.on('resize', () => {
      if ($quickLinks.length > 0 && matchMedia('(max-width: 900px)').matches) {
        html.addClass('header_fill');
        headerFill = true;
      } else {
        html.removeClass('header_fill')
      }
    })
  }

  if (headerFill == false) {
    header.on('mouseenter mousemove', function () {
      html.addClass('header_fill');
      if ($(body).hasClass('template-blog-nightstand')) {
        $(body).addClass('hover-header');
      }
    }).mouseleave(function () {
      if (!html.hasClass('search_pane_active') &&
        !html.hasClass('mobile_menu_active')) {
        (scrollTop == 0 &&
          !html.hasClass('mobile_menu_active'))
          ? html.removeClass('header_fill')
          : html.addClass('header_fill');
      }

      if ($(body).hasClass('template-blog-nightstand')) {
        html.removeClass('header_fill')
      }
      $(body).removeClass('hover-header');
    });
  }

  // header menu
  const menuClose = () => {
    menuCloseTrigger = setTimeout(function () {
      $(`[data-header-menu-trigger],
				[data-header-menu]`).removeClass('active');
    }, 0);
  }
  menuOpenTrigger = menuCloseTrigger = null;

  $('[data-header-menu-trigger]').mouseenter(function () {
    let _this = $(this);
    menuOpenTrigger = setTimeout(function () {
      _this.addClass('active')
        .siblings().removeClass('active');
      hj('trigger', 'mega_menu');
      $(`.header-menu[data-header-menu="${_this.attr('data-header-menu-trigger')}"]`).addClass('active')
        .siblings('.header-menu').removeClass('active');
    }, 150);

    clearTimeout(menuCloseTrigger);
  }).mouseleave(function () {
    clearTimeout(menuOpenTrigger);
    menuClose();
    document.removeEventListener('keydown', (e) => closeDesktopMenu(e))
  });

  const closeDesktopMenu = (event) => {
    if (event.key === 'Escape' || event.key === 'Esc') {
      clearTimeout(menuOpenTrigger);
      menuClose();
    }
  }

  document.addEventListener('keydown', (e) => closeDesktopMenu(e))

  $('.main-nav__mega-menu-button').toggle(function () {
    let _this = $(this).parent();
    menuOpenTrigger = setTimeout(function () {
      _this.addClass('active')
        .siblings().removeClass('active');
      hj('trigger', 'mega_menu');
      $(`.header-menu[data-header-menu="${_this.attr('data-header-menu-trigger')}"]`).addClass('active')
        .siblings('.header-menu').removeClass('active');
    }, 150);

    clearTimeout(menuCloseTrigger);
  },function () {
    clearTimeout(menuOpenTrigger);
    menuClose();
  });
  $('[data-header-menu-trigger]').focusout(function(){
    if($(this).hasClass('active') > 0) {
      var menu_title =$(this).attr('data-header-menu-trigger');
      console.log(menu_title);
      console.log($('.header-menu[data-header-menu='+menu_title+'] .header-menu-links li:first-child .sub-link').first());
      $('.header-menu[data-header-menu='+menu_title+'] .header-menu-links .sub-link a').first().focus();
    }
  })
  $('.header-menu-blocks .header-menu-block:last-child').focusout(function(){
    
    $('.active.header-menu').removeClass('active');
    $('.active[data-header-menu-trigger]').next().focus();
    $('.active[data-header-menu-trigger]').next().find('a').focus();
  })

  $('.header-menu').mouseenter(function () {
    clearTimeout(menuCloseTrigger);
  }).mouseleave(menuClose);

  // responsive mobile menu
  const mobileMenuTrigger = $('#mobile-menu-trigger');
  const mobileMenuOverlay = $('#body-overlay');

  mobileMenuTrigger.click(function () {
    html.toggleClass('mobile_menu_active');

    if (headerFill == false && scrollTop <= 10) {
      (html.hasClass('mobile_menu_active'))
        ? html.addClass('header_fill')
        : html.removeClass('header_fill');
    }
  });

  mobileMenuOverlay.click(function () {
    html.removeClass('mobile_menu_active');

    (headerFill == false && scrollTop <= 10)
      ? html.removeClass('header_fill')
      : html.addClass('header_fill');
  });

  // move header-menus to mobile menu
  $('[data-header-menu]').clone()
    .prependTo('#mobile-menu-content');

  // open header-menus
  $('[data-mobile-menu-trigger]').click(function () {
    $(`.header-menu[data-header-menu="${$(this).attr('data-mobile-menu-trigger')}"]`).addClass('active')
      .siblings('.header-menu').removeClass('active');
  });

  // close header-menus
  $('.header-menu-close').click(function () {
    $(this).closest('.header-menu').removeClass('active');
  });

  _window.click(function (e) {
    let target = $(e.target);

    if (html.hasClass('mobile_menu_active') &&
      !target.is('#mobile-menu') &&
      !target.closest('#mobile-menu').length &&
      !target.is('#mobile-menu-trigger') &&
      !target.closest('#mobile-menu-trigger').length) {

      html.removeClass('mobile_menu_active');
    }
  });
}

const initNewsletterPopup = () => {
  const newsletter = $('#newsletter-popup');
  const newsletterClose = newsletter.find('#newsletter-popup-close');
  const newsletterId = 'viewSourceCreative' + '0111-3-2021';
  const timeNow = new Date().getTime();
  const timeSetup = localStorage.getItem('luNewsletterTimeSetup');

  // exit if no newsletter nor does browser have local storage capability
  if (!newsletter.length && hasLocalStorage !== true) {
    return false;
  }

  // if timer is not setup
  if (timeSetup === null) {
    localStorage.setItem('luNewsletterTimeSetup', timeNow);

    // if timer is setup, but passes expiration
  } else if (timeNow - timeSetup > 3 * 24 * 60 * 60 * 1000) {
    // reset timer
    localStorage.removeItem(newsletterId);
    localStorage.setItem('luNewsletterTimeSetup', timeNow);
  }

  // reveal newsletter popup after 3 seconds, if user has scrolled pass half window height
  newsletterActiveTrigger = setInterval(function () {
    if (window.location.pathname != '/challenge' &&
      localStorage.getItem(newsletterId) !== 'closed' &&
      scrollTop > windowHeight / 2) {
      html.addClass('newsletter_popup_active');
      clearInterval(newsletterActiveTrigger);
    }
  }, 3000);

  const newsletterCloseTrigger = () => {
    localStorage.setItem(newsletterId, 'closed');
    html.removeClass('newsletter_popup_active');

    setTimeout(function () {
      newsletter.remove();
    }, 600);
  }

  // close newsletter on click
  newsletterClose.click(newsletterCloseTrigger);
}

const initSearchPane = () => {
  const searchPaneTrigger = $('.header-search-pane-trigger');
  const searchPane = $('#header-search-pane');

  const searchForm = $('#header-search-form');
  const searchInput = searchForm.find('input[type="text"]');
  const searchClear = searchForm.find('#header-search-clear');
  const searchResults = $('#header-search-results');
  const searchUrl = `${routes.search_url}` || '/search';

  searchViewAllButton =
    productSearchRequest =
    articleSearchRequest =
    searchInputThrottle = null;

  const searchReset = () => {
    searchInput.val('');
    searchResults.empty();
    html.removeClass('search_pane_has_value');

    loadingBarTrigger('done');
  }

  const searchResultsTrigger = () => {
    clearTimeout(searchInputThrottle);

    searchInputThrottle = setTimeout(function () {
      let term = searchInput.val();

      if (term.length >= 3 &&
        term != searchInput.attr('data-term')) {
        // add active state
        html.addClass('search_pane_has_value');

        // register search term to avoid double triggering ajax
        searchInput.attr('data-term', term);

        // start loading state
        loadingBarTrigger('start');

        // if abort current ajax request, if exists
        (productSearchRequest !== null)
          ? productSearchRequest.abort() : '';

        (articleSearchRequest !== null)
          ? articleSearchRequest.abort() : '';

        // trigger ajax request
        productSearchRequest = $.getJSON(
          `${searchUrl}?type=product&q=${term}&view=json-data`
        ).always(function (data) {
          searchProductResults = '';

          if (data.results_count > 0) {
            searchViewAllButton = (data.results_count > 2)
              ? true : false;

            searchProductResults += `<div id="search-product-list">
							<h2 class="t-link cr-subdued">Products</h2>
              <ul class="t-b-2">`;

            $.each(data.results, function (i, item) {
              if (i < 2 && item.title.toLowerCase().indexOf("gift box") === -1) {
                searchProductResults += `<li
										class="search-product g-flex">
										<a href="${item.url}" title="${item.title}"></a>
										<div class="search-product-thumbnail thumbnail">
											${(!item.thumbnail.includes('no-image'))
                    ? `<span class="object-fit">
													<img
														src="${item.thumbnail}"
														alt="">
													</span>`
                    : ''
                  }
										</div>
										<div class="search-product-content">
											<div class="t-b-2">${item.title}</div>
											<div class="t-b-2 cr-subdued">${item.price}</div>
										</div>
									</li>`;
              }
            });
            searchProductResults += `</ul></div>`;
          }
        });

        articleSearchRequest = $.getJSON(
          `${searchUrl}?type=article&q=${term}&view=json-data`
        ).always(function (data) {
          searchArticleResults = '';

          if (data.results_count > 0) {
            searchViewAllButton = (searchViewAllButton == true ||
              data.results_count > 2)
              ? true : false;

            searchArticleResults += `<div id="search-article-list" class="t-b-2">
							<h2 class="t-link cr-subdued">Blog Posts</h2>
							<ul class="t-b-2">`;
            let articleCount = 0;
            $.each(data.results, function (i, item) {
              if (articleCount < 4 && !item.url.includes('/pages/') && item.url.includes('/blogs/nightstand/')) {
                searchArticleResults += `<li>
                  <a href="${item.url}">${item.title}</a>
                </li>`;
                articleCount++;
              }
            });

            searchArticleResults += `</ul>
						</div>`;
          }
        });

        $.when(
          productSearchRequest, articleSearchRequest
        ).done(function () {
          loadingBarTrigger('done');

          (searchArticleResults == '' &&
            searchProductResults == '')
            ? searchResults.addClass('no-results')
            : searchResults.removeClass('no-results')

          searchResults.html(`${(searchArticleResults == '' &&
            searchProductResults == '')
            ? `<div id="search-no-results">
								<div class="t-b-2 cr-gray-d">No results for your search term.</div>
							</div>`
            : `${searchProductResults}${searchArticleResults}${(searchViewAllButton == true)
              ? `<div id="search-results-view-all">
										<a
											class="btn-block"
											href="${`${searchUrl}?q=${term}`}">
											View All Results</a>
										</div>`
              : ''
            }`
            }`);
        });

      } else if (term.length == 0) {
        searchReset();
      }
    }, 450);
  }

  searchPaneTrigger.click(function () {
    html.toggleClass('search_pane_active');

    setTimeout(function () {
      html.hasClass('search_pane_active')
        ? searchInput.focus()
        : '';
    }, 300);
  });

  _window.click(function (e) {
    let target = $(e.target);

    if (html.hasClass('search_pane_active') &&
      !target.is('.header-search-pane-trigger') &&
      !target.closest('.header-search-pane-trigger').length &&
      !target.is('#header-search-pane') &&
      !target.closest('#header-search-pane').length) {

      html.removeClass('search_pane_active');
      setTimeout(searchReset, 300);
    }
  });

  searchInput.on('keyup change', searchResultsTrigger);

  searchForm.on('submit', function (e) {
    e.preventDefault();

    window.location.href = `${searchUrl}?q=${searchInput.val()}`;
  }).on('clearSearch', searchReset);

  searchClear.on('click', function (e) {
    e.preventDefault();

    searchReset();
  });
}

const initSearchIndex = () => {
  const searchHeaderInput = $('#search-header-input');
  const searchHeaderClear = $('#search-header-clear');

  searchHeaderInput.on('keyup change', function () {
    (searchHeaderInput.val())
      ? html.addClass('search_header_input_has_value')
      : html.removeClass('search_header_input_has_value')
  });

  searchHeaderClear.click(function () {
    searchHeaderInput.val('').focus();
  });

  const searchResultsTabButton = $('#search-results-tab button');

  searchResultsTabButton.click(function () {
    let _this = $(this);

    _this.addClass('active')
      .siblings().removeClass('active');

    _this.parent().attr('data-results-tab',
      _this.attr('data-results-tab-trigger'));
  });
}

const initFrontpage = () => {
  const hero = $('#frontpage-hero');
  ctaCollapseTimer = null;

  const frontpageScroll = () => {
    clearTimeout(ctaCollapseTimer);

    ctaCollapseTimer = setTimeout(function () {
      (scrollTop > windowHeight / 3)
        ? hero.addClass('cta_collapse')
        : hero.removeClass('cta_collapse');
    }, 150);
  }

  if (!screenIsTablet) {
    _window.scroll(frontpageScroll);
  }
}

const initCollectionListing = () => {
  $('#collection-listing-featured .slide-content-b a').each(function () {
    let _this = $(this);

    _this.attr('href', `#collection-listing-${formatHandleize(_this.siblings('.t-b-1').text())
      }`);
  });
}

const initProductIndex = () => {
  const collectionProducts = $('#collection-products');
  const toolbarMobile = $('#collection-toolbar-mobile');

  const toolbar = (!screenIsMobile)
    ? $('#collection-toolbar')
    : toolbarMobile;
  const toolbarContent = toolbar.find('#collection-toolbar-content');
  const toolbarDropdown = toolbar.find('.toolbar-dropdown');
  const toolbarDropdownTrigger = toolbar.find('[data-dropdown-trigger]');
  const productsInfiniteScroll = () => {
    collectionProducts.infinitescroll({
      errorCallback: function () {
        html.addClass('collection_load_end');
        loadingBarTrigger('done');
      }
    }, function (i) {
      $(i).addClass('css_fadeIn animate')
        .appendTo('.collection-products-grid:last .comp-grid-3');

      $(i).find('[data-swatch-image].active')
        .click().trigger('mouseenter');
      loadingBarTrigger('done');
    });
  }

  const removeEditorialBlocks = () => {
    $('.collection-products-editorial, .editorial-inline-1, .editorial-inline-2').remove();
    let PLPProducts = document.querySelectorAll(".collection-products-grid .comp-grid-3");
    let targetContainer = document.createElement("div");
    let wrapper = document.createElement("div");
    wrapper.classList.add("collection-products-grid", "width");
    targetContainer.classList.add("comp-grid-3","g-flex");
    for (let i = 0; i < PLPProducts.length; i++) {
      targetContainer.innerHTML += PLPProducts[i].innerHTML;
      PLPProducts[i].parentNode.remove();
    }
    targetContainer.querySelectorAll(".product-card-main").forEach((e)=>{
      e.style.opacity = 1;
    })
    wrapper.appendChild(targetContainer);
    document.getElementById("collection-products").prepend(wrapper);
  }

  const colorFilter = () => {
    $('#collection-products').css('visibility', 'hidden')
    $('#collection-load-more').css('display', 'none')

    let activeColor = (toolbar.find(`li.active [data-filter-trigger*="Color:"]`).attr('data-filter-trigger'))
      ? toolbar.find(`li.active [data-filter-trigger*="Color:"]`).attr('data-filter-trigger').replace('Color:', '')
      : false;
    let checkArray = JSON.parse(filter_colors) ?? []
    let colorExist, colorSplit
    if (activeColor) {
      colorExist = checkArray.find(color => color.main_color == activeColor)
      colorSplit = colorExist["subcolors"].toUpperCase().split(',')
    }

    if (colorExist) {
      document.querySelectorAll('.comp-product-card').forEach(function (container) {
        let swatches = container.querySelectorAll('[data-swatch-color]');
        let activeSwatch;
        swatches.forEach(function (swatch) {
          let colorFound = colorSplit.find(color => color == swatch.getAttribute('data-swatch-color').toUpperCase())
          if (colorFound) {
            container.querySelector(".product-card-main").classList.remove("lazyload");
            container.querySelector(".product-card-main").srcset = "";
            container.querySelector(".product-card-main").src = swatch.getAttribute("data-swatch-image");
            container.querySelector(".product-card-hover").classList.remove("lazyload");
            container.querySelector(".product-card-hover").srcset = "";
            container.querySelector(".product-card-hover").src = swatch.getAttribute("data-swatch-image-hover-src");
            container.querySelector(".product-url").href = swatch.getAttribute("data-url");
            var index = swatch.getAttribute("data-index");
            container.querySelectorAll(".color-btn").forEach((e)=>{
              e.classList.remove("active");
            })
            swatch.classList.add("active");
            container.querySelectorAll(".product-quickadd > ul").forEach((e)=>{
              e.classList.remove("active");
            });
            container.querySelector(".product-quickadd ul:nth-child("+index+")").classList.add("active");
          }
        })
      });
    }

    setTimeout(function () {
      $('#collection-products').css('visibility', 'visible')
    }, 300);

  }

  if (screenIsTablet) {
    toolbarMobile.find('#toolbar-mobile-filter-content')
      .prepend($('#collection-toolbar-filter').html());
  }

  colorFilter();

  // product loading
  productsInfiniteScroll();
  _window.unbind('.infscr');
  let page = 1
  _document.on('click', '#collection-load-more', function () {
    loadingBarTrigger('start');
    page = page + 1
    let url = window.location.href;
    if (url.indexOf("?")<0 ){url = url + `?page=${page}`;}
    else{url = url + `&page=${page}`}
    fetch(url)
      .then(response => response.text())
      .then(data => {
        loadingBarTrigger('move');
        let parser = new DOMParser().parseFromString(data, 'text/html');
        let result = parser.querySelector('.collection-products-grid .comp-grid-3');
        let PLPcards = Array.from(result.children).filter(card => card.classList.contains('comp-product-card'));
        let fragment = document.createDocumentFragment();
        PLPcards.forEach(card => {
          card.style.opacity = 1;
          if (card.querySelector(".product-quickadd__list")) {
            card.querySelector(".product-quickadd__list").classList.add("active");
          }
          if (card.querySelector(".product-card-main")) {
            card.querySelector(".product-card-main").style.opacity = 1;
          }
          fragment.appendChild(card);
          loadingBarTrigger('move');
        });
        let collectionGrid = document.querySelectorAll('.collection-products-grid');
        collectionGrid[collectionGrid.length - 1].querySelector(".comp-grid-3").appendChild(fragment);

    }).then(()=>{
      loadingBarTrigger('move');
      if((page + 1 > window.paginatePages)){
        document.querySelector("#collection-load-more").style.display = "none";
      }
      loadingBarTrigger('done');
    });
    $('#infscr-loading').remove();
  });

  // toggle filter/sort dropdowns
  const toolbarDropdownClose = () => {
    if (toolbar.find('.toolbar-dropdown.active')) {
      html.removeClass('toolbar_active');
      toolbar.find('.toolbar-dropdown.active').removeClass('active')
    }
  }

  toolbarDropdownTrigger.click(function () {
    let dropdownActive = $(this).closest('.toolbar-dropdown');

    if (dropdownActive.hasClass('active')) {
      toolbarDropdownClose();
    } else {
      html.addClass('toolbar_active');
      toolbarDropdown.removeClass('active');
      dropdownActive.addClass('active');
    }
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.toolbar-dropdown') && !e.target.closest('[data-swatch-image]')) {
      toolbarDropdownClose();
    }
  })

  // toolbar.on('mouseleave', toolbarDropdownClose);

  // toolbar and product filtering/sorting
  const toolbarCurrent = $('#collection-toolbar-current');
  collectionProductRequest = null;

  const toolbarRefresh = () => {
    let urlParams = new URLSearchParams(window.location.search);
    let urlParamsSort = urlParams.get('sort_by');

    // determine active state for sort
    if (urlParamsSort && urlParamsSort != 'manual') {
      toolbar.find(`[data-sort-trigger="${urlParamsSort}"]`).closest('li').addClass('active')
        .siblings().removeClass('active');
    }

    // determine active filters
    let filterActiveTerms = [];

    toolbar.find(`input:checked`).each(function () {
      filterActiveTerms.push($(this).val());
    });

    // if has terms
    if (filterActiveTerms.length) {
      // create toolbar current HTML
      toolbarCurrent.html(`
				<ul>${filterActiveTerms.map(item =>
        `<li>
						<button data-filter-clear-trigger="${item}">${item.split('=')[1].replaceAll("%20", " ").replaceAll("%26", "&")}</button>
					</li>`
      ).join('')}</ul>

				<button data-filter-clear-trigger="all">Clear</button>
			`).show();
      removeEditorialBlocks();
    } else {
      // else, clear toolbar
      toolbarCurrent.empty().hide();
    }
  }

  const productRefresh = () => {
    // trigger fade in for all sections due to the shift in product grid height
    $('[data-ani-anchor]:not(.animate)').addClass('animate');

    // if abort current ajax request, if exists
    (collectionProductRequest !== null)
      ? collectionProductRequest.abort() : '';

    // initiate loading bar
    loadingBarTrigger('start');

    // fade out product grid
    collectionProducts.addClass('css_fadeOut')
      .removeClass('css_fadeIn');

    // generate filter URL
    let filterActiveTerms = [];
    let sortActiveTerm = $('li.active [data-sort-trigger]').attr('data-sort-trigger');

    let t = screenIsTablet ? toolbarMobile : toolbar;
    t.find('[data-filter-option]:checked').each(function () {
      let tag = $(this).val();
      (!filterActiveTerms.includes(tag))
        ? filterActiveTerms.push(tag) : '';
    });
    let filterUrl = `${collectionUrl}?`;
    if(filterActiveTerms.length){
      filterUrl += filterActiveTerms.join('&');
      if(sortActiveTerm && sortActiveTerm != 'manual'){
        filterUrl += `&sort_by=${sortActiveTerm}`;
      }
    }else if(sortActiveTerm && sortActiveTerm != 'manual'){
      filterUrl += `sort_by=${sortActiveTerm}`;
    }
    // trigger ajax request for products
    collectionProductRequest = $.ajax({
      url: filterUrl,
      context: document.body
    }).done(function (data) {
      const pattern = /window.paginatePages\s*=\s*(\d+)/;
      const match = data.match(pattern);
      if (match) {
        window.paginatePages = parseInt(match[1], 10);
      }
      history.pushState({}, '', filterUrl);

      // refresh toolbar
      toolbarRefresh();
      // replace products
      if ($(data).find('#collection-products').length) {
        $(document).find('#collection-products').html($(data).find('#collection-products').html());
        collectionProducts.find('[data-swatch-image].active')
          .click().trigger('mouseenter');
        collectionProducts.find("ul").addClass("active");
        $('#collection-products [data-ani-anchor]').addClass('animate');

        setTimeout(removeEditorialBlocks, 1);
      } else {
        let emptyCollectionHtml = $(data).find('#collection-empty');

        emptyCollectionHtml.find('p').html('There are no items matching your filters – reset the filters or try a different category to continue.')
          .after(`<button
					class="btn-block"
					data-filter-clear-trigger="all">
					Reset Filters</button>`);

        collectionProducts.html(`<div id="collection-empty">
					${emptyCollectionHtml.html()}
				</div>`);
      }
      colorFilter();
      // fade in product grid
      setTimeout(function () {
        collectionProducts.addClass('css_fadeIn')
          .removeClass('css_fadeOut');
      }, 10);

      // determine if load more is needed

      if ($(data).find('#collection-load-more').length) {
        // if load more button already exists
        if ($('#collection-load-more').length) {
          // show load more button
          $('#collection-load-more').show();
          // and update load url
          $('#infinite-next a').attr('href', $(data).attr('href'));
        } else {
          // else, grab from new page
          collectionProducts.after(`
						${$(data).find('#collection-load-more').prop('outerHTML')}
						${$(data).find('#infinite-next').prop('outerHTML')}
					`);
        }

        productsInfiniteScroll();
      } else {
        $('#collection-load-more').hide();
      }

      // update product counts
      let productLength = collectionProducts.find('.comp-product-card').length;

      toolbarCurrent.append(`<div
				id="toolbar-filter-count"
				class="cr-subdued t-caption">
				${productLength} Item${(productLength > 1) ? 's' : ''}
			</div>`);
      //refresh collection functionality
      // end loading bar
      loadingBarTrigger('done');

      // scroll to grid
      scrollTo('#collection-grid');
    });
  }

  // reset toolbar on load
  toolbarRefresh();

  $('[data-filter-option]').on('change', () => {
    let _this = $(this);

    if (screenIsTablet) {
      let activeFilterCount = toolbarMobile.find('[data-filter-option]:checked').length;
      toolbarMobile.find('#toolbar-mobile-filter-apply').text((activeFilterCount > 0)
        ? `Apply (${activeFilterCount})`
        : `Apply`);
    } else {
      productRefresh();
    }
  });

  $('[data-filter-list-close]').on('click', () => {
    toolbarDropdownClose();
  })

  $('#toolbar-mobile-filter-apply').on('click', () => {
    productRefresh();
  })

  _document.on('click', '[data-filter-trigger]', function () {
    let _this = $(this);
    let filter = this.getAttribute("data-filter-trigger");
    if (_this.closest('#collection-toolbar').length ||
      _this.closest('#toolbar-mobile-filter').length) {
      _this.closest('li').toggleClass('active')
        .siblings().removeClass('active');
    } else {
      let filterTags = _this.attr('data-filter-trigger').split(',');
      // clear current active
      toolbar.find(`[data-filter-trigger]`).removeClass('active');

      // loop through clicked filter (multi-option capability.)
      for (let i = 0; i < filterTags.length; ++i) {
        // assign active state
        toolbar.find(`[data-filter-trigger="${filterTags[i]}"]`)
          .closest('li').addClass('active')
          .siblings().removeClass('active');
      }

      let filterArr = filter.split("||");
      filterArr.forEach((a)=>{
        if(filter != 'accept'){
          let t = screenIsTablet ? toolbarMobile : toolbar;
          const target = t.find(`input[value="${a}"]`)
          target.prop('checked', true)
        }
      })

      productRefresh();
      toolbarDropdownClose();
    }

    if (screenIsTablet) {
      let activeFilterCount = toolbarMobile.find('li.active [data-filter-trigger]').length;

      toolbarMobile.find('#toolbar-mobile-filter-apply').text((activeFilterCount > 0)
        ? `Apply (${activeFilterCount})`
        : `Apply`);
    } else {
      productRefresh();
      toolbarDropdownClose();
    }
  });

  _document.on('click', '[data-sort-trigger]', function () {
    $(this).closest('li').toggleClass('active')
      .siblings().removeClass('active');

    productRefresh();

    if (!screenIsTablet) {
      toolbarDropdownClose();
    }
  });

  _document.on('click', '[data-filter-clear-trigger]', function () {
    let term = $(this).attr('data-filter-clear-trigger');
    (term == 'all')
      // clear all filtering, reload page because we can't reverse removeEditorialBlocks();
      ? window.location.href = collectionUrl
      // clear individual filter
      : $(`input[value="${term}"]`).prop('checked', false);
    productRefresh();
  });

  // mobile toolbar
  toolbarMobile.find('#toolbar-mobile-filter-trigger').click(function () {
    html.toggleClass('toolbar_mobile_filter_active');

    scrollTo('#toolbar-mobile-trigger');
  });

  toolbarMobile.find('#toolbar-mobile-filter-cancel').click(function () {
    html.removeClass('toolbar_mobile_filter_active')
  });

  toolbarMobile.find('#toolbar-mobile-filter-apply').click(function () {
    html.removeClass('toolbar_mobile_filter_active');
    productRefresh();
  });

  toolbarMobile.find('#toolbar-mobile-sort-trigger').change(function () {
    html.removeClass('toolbar_mobile_filter_active');

    $(`[data-sort-trigger="${toolbarMobile.find('#toolbar-mobile-sort-trigger').val()}"]`).click();
  });
}
const initProductSingle = () => {
  // images
  const heroImagesListImage = $('#hero-images-featured-interior [data-image]');
  const heroImagesFeaturedImages = $('#hero-images-featured .image');
  var modela = "", modelb = "";
  let findVariant = $('#variant-swatch-container').find('button.active');
  if (typeof findVariant != "undefined") {
    if (typeof findVariant.attr("data-model-a") != "undefined") {
      modela = findVariant.attr("data-model-a").toLowerCase();
    }
    if (typeof findVariant.attr("data-model-b") != "undefined") {
      modelb = findVariant.attr("data-model-b").toLowerCase();
    }
  }
  let productNotHiddenImagesDesktop = $('#product-hero-images.desktop-only #hero-images-featured-interior .thumbnail.image:not(".hidden")').not(".hide")
  if (modela == null && modelb == null) {
    $('.product-image-tab').addClass('hide');
  }
  else {
    if (modela.length > 0 && modelb.length > 0) {
      $('.product-image-tab').removeClass('hide');
    } else {
      $('.product-image-tab').addClass('hide');
    }
  }
  if (window.matchMedia("(max-width: 768px)").matches) {
    modela = 'MODEL WEARS ' + modela;
    modelb = 'MODEL WEARS ' + modelb;
  }
  $('.model-info-1').html(modela)
  $('.model-info-2').html(modelb)


	const imageHideBasedOnSize = () => {
		let variantActive = $('.product-variants [data-variant-id].active');
		imageShowIndex = [];
		imageHasSizeIndex = [];
		var modela = "", modelb = "", selectedSize = "";
		let findVariant = $('#variant-swatch-container').find('button.active');
		if (typeof findVariant != "undefined") {
			if (typeof findVariant.attr("data-model-a") != "undefined") {
				modela = findVariant.attr("data-model-a").toLowerCase();
			}
			if (typeof findVariant.attr("data-model-b") != "undefined") {
				modelb = findVariant.attr("data-model-b").toLowerCase();
			}
		}
		let productNotHiddenImagesDesktop = $('#product-hero-images.desktop-only #hero-images-featured-interior .thumbnail.image:not(".hidden")').not(".hide")
		if (modela == null && modelb == null) {
			$('.product-image-tab').addClass('hide');
		}
		else {
			if (modela.length > 0 && modelb.length > 0) {
				$('.product-image-tab').removeClass('hide');
			} else {
				$('.product-image-tab').addClass('hide');
			}
		}
		$('.model-info-1').html(modela)
		$('.model-info-2').html(modelb)
			selectedSize = variantActive.text().trim();
		$('.variant-banner, .variant-banner-mobile').each(function () {
          $(this).removeClass('active');
          if(selectedSize.includes("1X")||selectedSize.includes("2X")){
            $('.model-info-2').addClass("active");
          }else{
            $('.model-info-1').addClass("active");
          }
		})
		heroImagesListImage.each(function (i) {
			let alt = $(this).attr('data-image-alt');
			let altSize = alt.substring(
				alt.lastIndexOf(':') + 1,
				alt.lastIndexOf('@')).split(',');
			if (altSize[0] && !altSize[0].includes('iframe')) {
				if (modela != null && modelb != null) {
					if (modela.indexOf(selectedSize) > -1 || modelb.indexOf(selectedSize) > -1) {
						imageHasSizeIndex.push(i);

            if (altSize.includes(variantActive.text().trim())) {
              imageShowIndex.push(i);
            }
          }
        }
      }
    });
    heroImagesListImage.each(function (i) {
      let _this = $(this);
      if (_this.parent().is('hidden')) _this.unwrap();
      _this.removeClass('hidden');

      if (imageShowIndex.length) {
        if (!imageShowIndex.includes(i)) {
          _this.addClass('hidden');
          _this.wrap('<hidden>');
        }
      } else if (imageHasSizeIndex.includes(i)) {
        _this.addClass('hidden');
        _this.wrap('<hidden>');
      }
    });
	}

  heroImagesListImage.click(function () {
    let _this = $(this);

    _this.addClass('active')
      .siblings().removeClass('active');

    $(heroImagesFeaturedImages[_this.attr('data-image')])
      .addClass('active')
      .siblings().removeClass('active');
  });

  if (screenIsTablet) {
    $('#hero-images-featured-interior').removeClass('thumbnail');

    $('#hero-images-list').remove();
    // $('#product-images-popup').remove();
  }
  imageHideBasedOnSize()
  initImageGallery();

  // swatches
  $('.product-variants [data-swatch-color]').mouseenter(function () {
    let _this = $(this);

    _this.closest('.product-variants').find('.product-variants-label')
      .text(_this.attr('data-swatch-color'));
  }).mouseleave(function () {
    let productVariants = $(this).closest('.product-variants');

		productVariants.find('.product-variants-label').text(
			productVariants.find('[data-swatch-color].active').attr('data-swatch-color'));
	});

	// sizes and other variants

	$(document).on('click change','.product-variants [data-variant-id]', function (e) {
		e.preventDefault();
		let _this = $(this);
		let variantId = _this.attr('data-variant-id');
    const $productHero = $(this).closest('comp-product-hero');

    if(this.closest(".product-variants-default")){
      this.closest(".product-variants-default").querySelectorAll(".t-link").forEach((el)=>{
        el.classList.remove("active");
      })
      this.classList.add("active");
    }
    // update quickadd trigger
    _this.closest('.product-form').find('[data-quickadd-id]')
      .attr('data-quickadd-id', variantId);

    imageHideBasedOnSize();
    galleryPopupHide();

    // sync selection with other variant selectors
    if (e.type == 'click') {
      $(`[data-variant-id="${$(this).attr('data-variant-id')}"]`).trigger('change');
    }

		// Update sticky color name and variation
		const stickySelection = $('#sticky-header-selections');
		const swatchListItem = stickySelection.find('.selection-swatch ul li[data-variant="' + variantId + '"]');

		stickySelection.find('.selection-swatch .selection-label').html(swatchListItem.html());
		swatchListItem.addClass('active').siblings().removeClass('active');


		window.setTimeout(function(){
			const stickySelection = $('#sticky-header-selections');
			stickySelection.find('.selection-size-type ul li').each(function(){
				let _this = $(this);
				const vId = _this.attr('data-variant-size');
				const isSoldOut=$('button.t-link[data-size-value="' + vId + '"]').hasClass('sold-out');

				if(isSoldOut === true){
					_this.addClass('sold-out');
				}else{
					_this.removeClass('sold-out');
				}
			});
		  }, 1000);


		const sizeAttr = _this.attr('data-size-value');
		if (typeof sizeAttr !== 'undefined' && sizeAttr !== false) {
			const sizeText = sizeAttr
				.replace('X', 'Extra ')
				.replace('M', 'Medium')
				.replace('S', 'Small')
				.replace('L', 'Large')
				.replace('OSmall', 'One Size')
			stickySelection.find('.selection-size-type .selection-label').html(sizeText);
			stickySelection.find('.selection-size-type ul li[data-variant-size="' + sizeAttr + '"]').addClass('active').siblings().removeClass('active');
		}
	});

	// accordions
	$('#hero-accordions .accordion-title').click(function () {
		$(this).siblings('.accordion-content').slideToggle()
			.closest('.accordion').toggleClass('active')
			.siblings().removeClass('active')
			.find('.accordion-content').slideUp();
	});

  // share
  const shareUrl = $('#product-share-url');
  const shareUrlSpan = shareUrl.find('span');

  shareUrl.click(function () {
    let urlInput = document.createElement('input');

    document.body.appendChild(urlInput);
    urlInput.value = window.location.href;
    urlInput.select();
    document.execCommand('copy');
    document.body.removeChild(urlInput);

    shareUrlSpan.text('Copied!');

    setTimeout(function () {
      shareUrl.mouseleave(function () {
        shareUrlSpan.text('Copy article URL');
      });
    }, 200);
  });

  // sticky header
  const stickyHeader = $('#product-sticky-header');
  const stickyHeaderSubmit = stickyHeader.find('[type="submit"]');
  const productSingleScroll = () => {
    (scrollTop > windowHeight)
      ? stickyHeader.addClass('active')
      : stickyHeader.removeClass('active');
  }

  siteReadyTrigger(productSingleScroll);
  _window.scroll(productSingleScroll);

  stickyHeader.find('.selection').each(function () {
    let selection = $(this);
    let label = selection.find('.selection-label');

    // set label to the selected variant on load
    label.html(selection.find('li.active').html());

    // if only has one option, remove dropdown and caret
    if (selection.find('li').length == 1 && window.varData == undefined) {
      selection.addClass('single-option')
        .find('ul').remove();
    }

    // reveal dropdown
    label.click(function () {
      selection.find("ul").toggleClass('active');
    });

    // list item selection
    selection.find('li').on('click change', function (e) {
      let _this = $(this);

      // assign active state
      selection.removeClass('active');

      _this.addClass('active')
        .siblings().removeClass('active');
      if (_this.attr('data-variant-url')) {
        window.location.href = _this.attr('data-variant-url');
      } else {
        label.html(_this.html());

        stickyHeaderSubmit.attr('data-quickadd-id',
          _this.attr('data-variant-id'));
      }

      (_this.hasClass('sold-out'))
        ? stickyHeader.find('[type="submit"]').text('Join Waitlist').attr('data-sold-out', '')
        : stickyHeader.find('[type="submit"]').text('Add to Bag')

      // sync selection with other variant selectors
      if (e.type == 'click') {
        $(`[data-variant-id="${_this.attr('data-variant-id')}"]`).trigger('change');
      }
    });
  });

  _window.click(function (e) {
    let target = $(e.target);

    if (stickyHeader.find('.selection.active').length &&
      !target.hasClass('selection') &&
      !target.closest('.selection').length) {
      stickyHeader.find('.selection.active')
        .removeClass('active');
    }
  });
}

const initCart = () => {
	const minicartTrigger = $('#minicart-trigger');
	const minicartClose = $('#minicart-close, #minicart-overlay');

  const itemGiftBoxExclude = () => {
    let item = (html.is('#cart'))
      ? $('#cart-content .line-item')
      : $('#minicart-content .line-item');

    // hide gift item if cart only contains digital gift card
    if (item.length == 2 &&
      item.attr('data-product-title') == 'Digital Gift Card') {
      $('.gift-note-clear').click();

      if ($('#giftbox-add').prop('checked') == true) {
        $('#giftbox-add').click();
      }
    }
  }

  window.cartTotalUpdate = () => {
    /* let totalPrice = $('.cart-total-price');
    let itemCount = $('.cart-item-count'); */
    let cartTotalPrice = $('.cart-total-price-2');
    let cartItemCount = $('.cart-item-count-2');
    let item = (html.is('#cart'))
      ? $('#cart-content .line-item')
      : $('#minicart-content .line-item')

    totalPriceChange = totalItemCount = 0;

    // loop through each item
    item.each(function () {
      let item = $(this);

      // There was an error that showed NaN for wanting to capture the number of a string with a method that did not consider all the options, a regular expression was used to solve this.

      let itemQuantity = item.find('.item-quantity-current').length
        ? parseInt($(item.find('.item-quantity-current')[0]).text().match(/(\d+)/g)[0])
        : (item.is('#cart-giftbox'))
          ? $('#giftbox-add').prop('checked') == true
            ? 1
            : 0
          : 1;

      let itemPrice = item.find('.item-price').length
        ? parseInt(item.find('.item-price').text().replace(/[^0-9&.]/g, ''))
        : item.attr('data-item-price');

      // multiply price and quantity, and add to total value
      totalPriceChange += parseFloat(itemPrice) * parseFloat(itemQuantity);
      totalItemCount += parseFloat(itemQuantity);
    });

    // clear gift item if it's the only one left in cart
    if ($('#giftbox-add').length &&
      $('#giftbox-add').prop('checked') == true) {
      totalItemCount = totalItemCount - 1;
    }

    itemGiftBoxExclude();

    // update cart total values
    cartTotalPrice.html(formatMoney(totalPriceChange));
    cartItemCount.text(totalItemCount);

    // determine whether item exists
    if (totalItemCount == 0) {
      minicartTrigger.removeClass('has_items');
      $('#cart-content, #minicart').removeClass('has_items');

      $.post(`/cart/update.js?updates[${window.theme.giftbox_id}]=0`);
      $('[data-js-add-gift-box]').prop('checked', false);
    } else {
      minicartTrigger.addClass('has_items');
      $('#cart-content, #minicart').addClass('has_items');
    }

    jQuery.getJSON('/cart.js', function (cart) {
      $('.cart-item-count').html(cart.item_count)
      $('.cart-total-price').html(formatMoney(cart.total_price / 100));
    })
  }

  const cartReload = (openCart, reloadPage, variantId = 0) => {

    jQuery.getJSON('/cart.js', function (cart) {
      let freeCartProducts1 = document.querySelectorAll('[data-product-id="' + productId1 + '"][data-item-price="0.00"]') ? document.querySelectorAll('[data-product-id="' + productId1 + '"][data-item-price="0.00"]') : null;
      let freeCartProducts2 = document.querySelectorAll('[data-product-id="' + productId2 + '"][data-item-price="0.00"]') ? document.querySelectorAll('[data-product-id="' + productId2 + '"][data-item-price="0.00"]') : null;

      if (cart.item_count < 1) {
        freeCartProducts1.forEach(element => {
          element.remove();
        });
        freeCartProducts2.forEach(element => {
          element.remove();
        });
      }
    })

    $.ajax({
      url: '/cart',
      dataType: 'html',
      error: function (data) {
        console.error(data);

        loadingBarTrigger('done');
      },
      success: function (data) {
        let minicartContent = $('#minicart-content');
        let cartItemsHtml = $(data).find('#cart-content #cart-items').html();

        // insert or prepend cart HTML
        (minicartContent.find('#cart-items').length)
          ? minicartContent.find('#cart-items').html(cartItemsHtml)
          : minicartContent.prepend(cartItemsHtml);

        // remove giftbox content if exists
        (minicartContent.find('#cart-giftbox .item-info').length)
          ? minicartContent.find('#cart-giftbox .item-info').remove()
          : '';

        loadingBarTrigger('done');
        cartTotalUpdate();

        window._rkUnloadPage('ajax_cart');
        window._rkLoadPage('ajax_cart');

        // open cart
        (openCart && !html.is('#cart'))
          ? minicartTrigger.trigger('click') : '';

        (reloadPage)
          ? location.reload() : '';

        $('.nogift').css('display', 'none');

        let freeCartProducts1 = document.querySelectorAll('[data-product-id="' + productId1 + '"][data-item-price="0.00"]') ? document.querySelectorAll('[data-product-id="' + productId1 + '"][data-item-price="0.00"]') : null;
        let freeCartProducts2 = document.querySelectorAll('[data-product-id="' + productId2 + '"][data-item-price="0.00"]') ? document.querySelectorAll('[data-product-id="' + productId2 + '"][data-item-price="0.00"]') : null;

        freeCartProducts1.forEach(element => {
          let qty = element.querySelector('.item-quantity')
          let qtyContainer = element.querySelector('.item-quantity-container')
          let hrefGift = element.querySelector('.object-fit')
          qty.style.display = 'none'
          qtyContainer.style.display = 'none'
          hrefGift.href = 'javascript:void(0)'
        });
        freeCartProducts2.forEach(element => {
          let qty = element.querySelector('.item-quantity')
          let qtyContainer = element.querySelector('.item-quantity-container')
          let hrefGift = element.querySelector('.object-fit')
          qty.style.display = 'none'
          qtyContainer.style.display = 'none'
          hrefGift.href = 'javascript:void(0)'
        });
      }
    });
  }

	if (frgiSystem) {
		if (productId1) {
			let freeCartProducts1 = document.querySelectorAll('[data-product-id="' + productId1 + '"][data-item-price="0.00"]');

			if (freeCartProducts1) {
				freeCartProducts1.forEach(element => {
					let qty = element.querySelector('.item-quantity')
					let qtyContainer = element.querySelector('.item-quantity-container')
					let hrefGift = element.querySelector('.object-fit')
					qty.style.display = 'none'
					qtyContainer.style.display = 'none'
					hrefGift.href = 'javascript:void(0)'
				});
			}
		}
		if (productId2) {
			let freeCartProducts2 = document.querySelectorAll('[data-product-id="' + productId2 + '"][data-item-price="0.00"]');

			if (freeCartProducts2) {
				freeCartProducts2.forEach(element => {
					let qty = element.querySelector('.item-quantity')
					let qtyContainer = element.querySelector('.item-quantity-container')
					let hrefGift = element.querySelector('.object-fit')
					qty.style.display = 'none'
					qtyContainer.style.display = 'none'
					hrefGift.href = 'javascript:void(0)'
				});
			}
		}
	}

	const itemUpdateGift = (key, qty, openCart, reloadPage) => {
		$.post(`/cart/update.js?updates[${key}]=${qty}`, function () {
		})
			.fail(function (e) {
				console.error(e)
			})
			.always(function () {
				setTimeout(function () {
					cartReload(openCart, reloadPage)
					controlGiftSystemUpdate(openCart, reloadPage)
				}, 250);
			});
	}

	window.controlGiftSystemUpdate = (openCart, reloadPage) => {

		let freeCartProducts1 = document.querySelectorAll('[data-product-id="' + productId1 + '"][data-item-price="0.00"]');
		let freeCartProducts2 = document.querySelectorAll('[data-product-id="' + productId2 + '"][data-item-price="0.00"]');
		let totalDigitalCards = 0;
		let cartTotal = 0;
		let qty1, qty2, cartQty = 0;
		jQuery.getJSON('/cart.js', function (cart) {
			cartTotal = cart.total_price;
			for (let i = 0; i < cart.items.length; i++) {
				cartQty = cartQty + cart.items[i].quantity;
				if (cart.items[i].sku.includes("GIFTCARD")) {

					totalDigitalCards = totalDigitalCards + parseInt(cart.items[i].quantity);
				}
				/* 			 	if ((cart.items[i].properties["isgift"] == "yes") && (cart.items[i].variant_id == variantGift1) && (cart.items[i].total_discount == 0)) {
									cartTotal = cartTotal - cart.items[i].line_price
								} */
				if ((cart.items[i].properties["isgift"] == "yes") && (cart.items[i].variant_id == variantGift1)) {
					qty1 = cart.items[i].quantity
				}
				if ((cart.items[i].properties["isgift"] == "yes") && (cart.items[i].variant_id == variantGift2) && (cart.items[i].total_discount == 0)) {
					cartTotal = cartTotal - cart.items[i].line_price
				}
				else if ((cart.items[i].properties["isgift"] == "yes") && (cart.items[i].variant_id == variantGift2) && (cartTotal < 250)) {
					cartTotal = cartTotal - cart.items[i].line_price
				}
				if ((cart.items[i].properties["isgift"] == "yes") && (cart.items[i].variant_id == variantGift2)) {
					qty2 = cart.items[i].quantity

				}
			}

			if (cartTotal >= (prd1Min * 100) && cartTotal < (prd1Max * 100)) {
				if (freeCartProducts2.length > 0) {
					for (let j = 0; j < cart.items.length; j++) {
						if ((cart.items[j].properties["isgift"] == "yes") && (cart.items[j].variant_id == variantGift2) && (cart.items[j].quantity > 0)) {
							freeCartProducts2.forEach(element => {
								element.remove();
							});
							itemUpdateGift(cart.items[j].key, 0, openCart, reloadPage)
							break;
						}
					}
				}
				else if (freeCartProducts1.length > 1) {
					for (let j = 0; j < cart.items.length; j++) {
						if ((cart.items[j].properties["isgift"] == "yes") && (cart.items[j].variant_id == variantGift1) && (cart.items[j].quantity > 1)) {
							itemUpdateGift(cart.items[j].key, 1, openCart, reloadPage)
						}
					}
				}
				else if (freeCartProducts1.length == 0) {
					if (cartQty != totalDigitalCards) {
						itemAddGiftUpdate(variantGift1, 1, openCart, reloadPage);
					}
				}

			}
			else if ((cartTotal >= (prd2Min * 100)) && (cartTotal < (prd2Max * 100))) {
				let match = false;
				if (qty1 > 0) {
					for (let j = 0; j < cart.items.length; j++) {
						if ((cart.items[j].properties["isgift"] == "yes") && (cart.items[j].variant_id == variantGift1) && (cart.items[j].quantity > 0)) {
							freeCartProducts1.forEach(element => {
								element.remove();
							});
							itemUpdateGift(cart.items[j].key, 0, openCart, reloadPage)
							break;
						}
					}
				}
				else if (freeCartProducts2.length > 1) {
					for (let j = 0; j < cart.items.length; j++) {
						if ((cart.items[j].properties["isgift"] == "yes") && (cart.items[j].variant_id == variantGift2) && (cart.items[j].quantity > 1)) {
							itemUpdateGift(cart.items[j].key, 1, openCart, reloadPage)
							break;
						}
					}
				}
				else if (freeCartProducts2.length == 0) {
					if (cartQty != totalDigitalCards) {
						itemAddGiftUpdate(variantGift2, 1, openCart, reloadPage);
					}
				}

			}
			else if (bothProducts && cartTotal >= (bothProductsTh * 100)) {
				if ((freeCartProducts1.length < 1)) {
					if (cartQty != totalDigitalCards) {
						itemAddGiftUpdate(variantGift1, 1, openCart, reloadPage);
					}
				}
				else if ((freeCartProducts1.length > 1)) {
					for (let j = 0; j < cart.items.length; j++) {
						if ((cart.items[j].properties["isgift"] == "yes") && (cart.items[j].variant_id == variantGift1) && (cart.items[j].quantity > 1)) {
							itemUpdateGift(cart.items[j].key, 1, openCart, reloadPage)
							break;
						}
					}
				}
				else if ((freeCartProducts2.length < 1)) {
					if (cartQty != totalDigitalCards) {
						itemAddGiftUpdate(variantGift2, 1, openCart, reloadPage);
					}
				}
				else if ((freeCartProducts2.length > 1)) {
					for (let j = 0; j < cart.items.length; j++) {
						if ((cart.items[j].properties["isgift"] == "yes") && (cart.items[j].variant_id == variantGift2) && (cart.items[j].quantity > 1)) {
							itemUpdateGift(cart.items[j].key, 1, openCart, reloadPage)
							break;
						}
					}
				}

			}
			else if (cartTotal < (prd1Min * 100)) {
				for (let j = 0; j < cart.items.length; j++) {
					if ((cart.items[j].properties["isgift"] == "yes") && (cart.items[j].variant_id == variantGift1)) {
						itemUpdateGift(cart.items[j].key, 0, openCart, reloadPage)
					}
					if ((cart.items[j].properties["isgift"] == "yes") && (cart.items[j].variant_id == variantGift2)) {
						itemUpdateGift(cart.items[j].key, 0, openCart, reloadPage)
					}
				}
			}
			for (let j = 0; j < cart.items.length; j++) {
				if ((cart.items[j].properties["isgift"] == "yes") && ((cart.items[j].variant_id == variantGift1) || (cart.items[j].variant_id == variantGift2))) {
					cartQty = cartQty - cart.items[j].quantity;
					if (cartQty == totalDigitalCards) {
						itemUpdateGift(cart.items[j].key, 0, openCart, reloadPage);
					}
				}
			}
		});
	}

	const itemAddGiftUpdate = (variant, qty, openCart, reloadPage) => {
		$.ajax({
			type: 'POST',
			dataType: 'html',
			url: `/cart/add.js`,
			data: {
				id: variant,
				quantity: qty,
				properties: {
					'isgift': 'yes'
				}
			},
			error: function (data) {
				console.error(data);
			},
			success: function () {
				cartReload(openCart, reloadPage);
			}
		});
	}

	// reload cart if page is loaded from bfcache
	window.onpageshow = function (event) {
		if (event.persisted) {
			cartReload(false, false);
		}
	}

	// remove items
	_document.on('click', '.item-remove-kit', function () {
		let _this = $(this);
		let kitName = $(this).attr('data-kit-name')
		let kitNameOrder = $(this).attr('data-kit-name-order')
		let items = $('.item[data-kit-name-order=' + kitNameOrder + ']')
		let removeSection = $('.remove-section[data-kit-name-order=' + kitNameOrder + ']')
		itemsId = []
		let updateString = ''
		items.each(function (index, value) {
			updateString = updateString.concat("updates[" + $(this).attr('data-item-key') + "]=0&")
		})
		loadingBarTrigger('start');
		let openCart = (!_this.closest('#minicart-content').length) ? true : false
		let reloadPage = (_this.closest('#cart-related').length) ? true : false
		$.post('/cart/update.js', updateString).always(function (data) {
			loadingBarTrigger('move');
			cartReload(openCart, reloadPage);
			removeKits(items, removeSection)
		})
	});

	const removeKits = (items, removeSection) => {
		removeSection.remove();
		items.each(function () {
			$(this).remove();
		})

	}

	// quick add

	const acceleratedCheckout = () => {
		var executed = false;
		return function () {
			if (!executed) {
				executed = true;
				let variantId = $("#add-to-cart-btn").attr('data-quickadd-id');
				$.ajax({
					type: 'POST',
					dataType: 'html',
					url: `/cart/add.js`,
					data: {
						id: variantId,
						quantity: 1
					},
					error: function (data) {
						console.error(data);
					},
					success: function () {
						$("[data-testid=ApplePay-button]").click()
					}
				});
			}
		};
	}
	_document.on("click", ".additional-checkout-buttons-pdp", acceleratedCheckout())
	_document.on('click', '[data-quickadd-id]', function (e) {
		let _this = $(this);
		let emb = $('#embroidery')
		let color = $('#swatch-emb button.active')
		if (emb.val() != '' && emb.is(":visible")) {
			_this.attr('data-embroidery', emb.val())
			_this.attr('data-embroidery-color', color.attr('data-swatch-color-emb').toUpperCase())
		}

    if (!window.matchMedia("(max-width: 600px)").matches) {
      // If desktop
      if (_this[0].classList.contains('sold-out')) {
        document.documentElement.classList.add('show-waitlist');
        const waitlistModal = document.querySelector('waitlist-modal');
        waitlistModal.style.display = 'block'
        initWaitlistvalues(_this);
      }
    } else {
      if (_this[0].classList.contains('sold-out') && _this[0].classList.contains('quick-add-trigger')) {
        const quickAddForm = _this.closest('.product-quickadd');
        const activeSoldoutBtn = quickAddForm.find('.quick-add-btn.sold-out.active');
        const firstSoldoutBtn =  quickAddForm.find('.quick-add-btn.sold-out').first();
        const btn = activeSoldoutBtn.length > 0 ? activeSoldoutBtn : firstSoldoutBtn;
        document.documentElement.classList.add('show-waitlist');
        const waitlistModal = document.querySelector('waitlist-modal');
        waitlistModal.style.display = 'block'
        initWaitlistvalues(btn);
      }
    }
	});

	String.prototype.replaceAll = function (search, replacement) {
		var target = this;
		return target.replace(new RegExp(search, 'g'), replacement);
	};

	_document.on('click', '.swatch-btn-kit', function () {
		let _this = $(this);
		let handle = _this.attr('data-swatch-handle')
		let colorSelected = _this.attr('data-swatch-color')
		let img = _this.closest('.product-kit-item').find('img');
		let newImg = _this.attr('data-swatch-image')
		let sizes = $('.size-kit[data-kit-handle="' + handle + '"]')
		let addKit = $('#add-to-cart-kit');
    _this.closest(".product-variants").find(".product-variants-label").text(colorSelected);
		img.attr('data-src', newImg)
		img.attr('data-srcset', newImg)
		img.attr('src', newImg)
		img.attr('srcset', newImg);
        _this.addClass('active')
        .siblings().removeClass('active');
		let allSizes = $('.size-kit.active');
		if (allSizes.length <= 1) {
			addKit.prop('disabled', true);
		}
		else {
			addKit.prop('disabled', false);
		}
	})

	_document.on('click', '.size-kit', function () {
		if ($(this).hasClass('sold-out')) {
		}
		let allSizes = $('.size-kit.active');
		let addKit = $('#add-to-cart-kit')
		if (allSizes.length <= 1) {
			addKit.prop('disabled', true);
		}
		else {
			addKit.prop('disabled', false);
		}
	})
	// quick add KIT
	_document.on('click', '[data-quickadd-kit-id]', function () {
		let _this = $(this);
		let productForms = $('.product-kit-form')
		let productKitIds = []
		let kit_key = new Date().valueOf();
		productForms.each(function (index) {
			let color = $(this).find('.swatch-btn-kit.active').attr('data-swatch-color');
			let size = $(this).find('.size-btn.active').attr('data-variant-value')
			let handle = $(this).attr('data-product-kit-name').replaceAll(' ', '-').replaceAll('"','');
			let realHandle = $(this).attr('data-product-handle')
			let discountValue = parseInt($(this).attr('data-product-kit-discount'))
      let variantId = $(this).find('.size-btn.active').attr('data-variant-id');
      productKitIds.push({ id: variantId, qty: 1, properties: { "kitkey": kit_key, "kitdiscount": discountValue, "kitindex": index, 'iskit': 'yes', 'kitname': handle } })
		})

		let openCart = (!_this.closest('#minicart-content').length) ? true : false
		let reloadPage = (_this.closest('#cart-related').length) ? true : false
		$.ajax({
			type: 'POST',
			dataType: 'html',
			url: `/cart/add.js`,
			data: { items: productKitIds },
			error: function (data) {
				console.error(data);
				loadingBarTrigger('done');

			},
			success: function (data) {
				loadingBarTrigger('move');
				cartReload(openCart, reloadPage);
				setTimeout(function () {
					cartKitName(data)
				}, 1000);
			}
		});
	});

	const cartKitName = (data) => {
		let productForms = $('.product-kit-form')
		let dataItems = JSON.parse(data)
		if (productForms.length > 0) {
			productForms.each(function () {
				let kitHandle = $(this).attr('data-product-kit-name').replaceAll(' ', '-')
				let kitClasses = $(`.cart-kit-name--${kitHandle}`);
				kitClasses.first().removeClass('hide')
			})
		}
	}

  // Minicart actions
  minicartTrigger.click(function (e) {
    e.preventDefault();

    html.addClass('minicart_active');
  });

  minicartClose.click(function () {
    html.removeClass('minicart_active');
  });


  itemGiftBoxExclude();

  if (screenIsTablet) {
    $('#cart-summary').clone()
      .insertAfter('#cart-header .t-h-5').find('#summary-additional-buttons, .t-h-5').remove();
  }
}

const initBlogIndex = () => {
  const articlesList = $('#articles-list');

  siteReadyTrigger(function () {
    articlesList.isotope({
      itemSelector: '.article',
      layoutMode: 'masonry',
      isOriginLeft: false,
      masonry: {
        columnWidth: 1
      }
    });
  }, 100);
}

const initBlogSingle = () => {
  const content = $('#article-content');
  const stickyHeader = $('#article-sticky-header');
  const blogSingleScroll = () => {
    (scrollTop > windowHeight / 2)
      ? stickyHeader.addClass('active')
      : stickyHeader.removeClass('active');
  }

  siteReadyTrigger(blogSingleScroll);
  _window.scroll(blogSingleScroll);

  content.find('p:has(img)').each(function () {
    $(this).children().unwrap();
  });

  $('.article-share-trigger').on('click', function() {
    $(this).closest('.article-share').toggleClass('share-active');
  })

  $('.article-share-close').on('click', function() {
    $(this).closest('.article-share').removeClass('share-active');
  })

  // $('.article-share').each(function () {
  //   let share = $(this);

  //   share.width(share.width())
  //     .attr('data-original-width', share.width());

  //   share.find('.article-share-trigger').click(function () {
  //     share.toggleClass('share-active');

  //     (share.hasClass('share-active'))
  //       ? share.width(share.find('ul').width() + 30)
  //       : share.width(share.attr('data-original-width'));
  //   });
  // });
}

const initCompAppointmentEmbed = () => {
  $('[data-appointment-embed]').click(function (e) {
    e.preventDefault();

    if ($('#appointment-embed').length) {
      $('#appointment-embed-iframe').html(`<iframe src="${$(this).attr('data-appointment-embed')}?embed_domain=www.lunya.co&embed_type=PopupText"></iframe>`);
    } else {
      body.append(`
				<div
					id="appointment-embed"
					class="g-flex g-vertical user-select-disable">
					<div class="appointment-embed-overlay"></div>
					<div
						id="appointment-embed-iframe"
						class="width">
						<iframe src="${$(this).attr('data-appointment-embed')}?embed_domain=www.lunya.co&embed_type=PopupText"></iframe>
					</div>
					<button
						id="appointment-embed-close"
						class="comp-close"
						aria-label="Close lightbox">
						<svg class="svg-close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.85 14.85"><g><path d="M6.72 7.42L0 14.14l.71.71 6.71-6.72 6.72 6.72.71-.71-6.72-6.72L14.85.71 14.14 0 7.42 6.72.71 0 0 .71z" fill="currentColor" fill-rule="evenodd"/></g></svg></button>
				</div>
			`);
    }

    setTimeout(function () {
      html.addClass('appointment_embed_active');
    }, 10);
  });

  _document.on('click', '#appointment-embed-close, #appointment-embed-overlay',
    function () {
      html.removeClass('appointment_embed_active');
    });
}

const initLocationsSingle = () => {
  const stickyHeader = $('#locations-sticky-header');
  const locationsSingleScroll = () => {
    (scrollTop > windowHeight / 2)
      ? stickyHeader.addClass('active')
      : stickyHeader.removeClass('active');
  }

  siteReadyTrigger(locationsSingleScroll);
  _window.scroll(locationsSingleScroll);
}

const initCareers = () => {
  $('.position-details-trigger').click(function () {
    let _this = $(this);

    _this.siblings('.position-details').slideToggle();
    _this.toggleText('More Details', 'Less Details');
  });
}

const initCx = () => {
  // content page selection
  const aside = $('#cx-content-aside');
  const content = $('#cx-content');

  $(`#cx-content-aside a,
		[href*="#faq"],
		[href*="#contact"]`).click(function (e) {
    e.preventDefault();

    let _this = $(this);
    let contactActive = $(`[data-cx-tab="${_this.attr('href').replace('#', '').split('-')[0]}"]`);

    // assign active states
    (_this.closest('li').length)
      ? _this.closest('li').addClass('active')
        .siblings().removeClass('active')
      : $('#cx-content-aside li:first-of-type').addClass('active')
        .siblings().removeClass('active');

    contactActive.addClass('active')
      .siblings().removeClass('active');

    // adjust content height
    content.css({
      'height': content.height(),
      'transition': 'height 0.6s'
    });

    setTimeout(function () {
      content.height(contactActive.height());
    }, 100);

    setTimeout(function () {
      content.css({
        'height': 'auto',
        'transition': '0s'
      });
    }, 601);

    // scroll to position
    scrollTo(_this.attr('href'));

    // update window hash
    history.pushState(null, null, _this.attr('href'));
  });

  if (window.location.hash &&
    $(`[data-cx-tab="${window.location.hash.replace('#', '')}"]`).length) {
    aside.find(`a[href="#${window.location.hash.replace('#', '')}"]`).click();
  }

  // faq search
  const faqSearch = $('#faq-search');
  const faq = $('.faq');

  faqSearch.on('keyup change', function () {
    let searchQuery = formatHandleize(faqSearch.val());

    faq.hide();

    if (searchQuery) {
      html.addClass('faq_search_active');

      faq.each(function () {
        let _this = $(this);

        (formatHandleize(_this.text()).includes(searchQuery))
          ? _this.show()
          : '';
      });
    } else {
      html.removeClass('faq_search_active');
      faq.show();
    }
  });

  // contact form
  let contactForm = $('#cx-contact-form form');

  const contactFormSuccess = () => {
    contactForm.fadeOut();

    setTimeout(function () {
      contactForm.parent().append(`
				<div
					id="cx-contact-form-success"
					class="form-success">
				${contactForm.attr('data-success-message')}</div>
			`).fadeIn();
    }, 300);
  }

  contactForm.submit(function (e) {
    e.preventDefault();

    $.ajax({
      type: 'POST',
      url: contactForm.attr('action'),
      dataType: 'json',
      cache: false,
      data: contactForm.serialize(),
      beforeSend: function () {
        loadingBarTrigger('start');
      },
      error: function (error) {
        console.error(error);
      },
      success: function (response) {
        contactFormSuccess();
      }
    }).always(function () {
      loadingBarTrigger('done');
    });
  });

  if (window.location.href.indexOf('?contact_posted=true') != -1) {
    $('[href="#contact"]').click();
    contactFormSuccess();
  }
}

const initFabricCare = () => {
  if (screenIsTablet) {
    $('.block-content p').each(function () {
      let _this = $(this);

      _this.wrap('<div class="toggle"></div>')
        .find('strong').addClass('toggle-label')
        .append('<div class="toggle-button"></div>')
        .remove().clone().prependTo(_this.parent('.toggle'))
        .siblings('p').addClass('toggle-content');
    });
  }
}

const initValentinesDay = () => {
  let appDomain = 'https://makeyourselfathome.lunya.co';
  let imgAssetUrl = `${appDomain}/assets/`;
  let stateContent = $('#valentines-content');
  let stateLetter = $('[data-valentines-state="Letter"]');
  let stateSubmission = $('[data-valentines-state="Submission"]');
  let stateReferral = $('[data-valentines-state="Referral"]');
  let stateSuccess = $('[data-valentines-state="Success"]');

  siteReadyTrigger(function () {
    stateContent.height(stateContent.height());
  });

  let changeState = (state) => {
    state.addClass('active')
      .siblings().removeClass('active');

    stateContent.height(state.innerHeight());

    scrollTo('#valentines-content');
  }

  stateLetter.find('input[type="text"]').on('keyup', function () {
    let _this = $(this);
    let val = _this.val();

    _this.width((val.length + 2) * 11);

    (val)
      ? _this.addClass('has_value')
      : _this.removeClass('has_value');
  });

  formData = new FormData();

  stateLetter.find('form').submit(function (e) {
    e.preventDefault();

    // form submit init
    loadingBarTrigger('start');
    stateLetter.find('input[type="submit"]').css('opacity', 0)
      .siblings('hr').css('opacity', 0);

    // turn letter into canvas
    window.scrollTo(0, 0);

    html2canvas(document.querySelector('#valentines-letter'), {
      imageTimeout: 8000,
      useCORS: true,
    }).then(canvas => {
      let imgData = canvas.toDataURL('image/png');

      // convert canvas into base64image
      formData.append('base64Image', imgData);

      // switch to next screen
      loadingBarTrigger('move');
      changeState(stateSubmission);

      // upload converted png image
      $.ajax({
        'url': `${appDomain}/home/uploadImage`,
        'method': 'POST',
        'processData': false,
        'mimeType': 'multipart/form-data',
        'contentType': false,
        'data': formData,
        'async': false,
      }).done(function (res) {
        // append uploaded image url into form
        stateLetter.find('[name="img_url"]').val(res);

      }).always(function () {
        loadingBarTrigger('done');
        changeState(stateSubmission);
      });
    });
  });

  const formSubmission = (form, formNext, formSubmits) => {
    // form submission init
    formValidated = true;
    loadingBarTrigger('start');
    form.find('input[type="submit"]').prop('disabled', true);

    // validations
    form.find('input').each(function () {
      let input = $(this);

      if (!input.val() ||
        (input.attr('type') == 'email') && !validateEmail(input.val())) {
        input.closest('.field').addClass('error');
        formValidated = false;
        loadingBarTrigger('done');
        form.find('input[type="submit"]')
          .prop('disabled', false);
      } else {
        input.closest('.field').removeClass('error');
      }
    });

    // trigger submission
    if (formValidated == true) {
      let formData = new FormData();

      // loop through each form to construct data
      for (let i = 0; i < formSubmits.length; i++) {
        $.each(formSubmits[i].find('form').serializeArray(),
          function (key, input) {
            formData.append(input.name, input.value);
          });
      }

      // submit form data
      $.ajax({
        type: 'POST',
        processData: false,
        contentType: false,
        url: `${appDomain}${form.attr('action')}`,
        data: formData,
      }).done(function (data) {
        var res = $.parseJSON(data);
        loadingBarTrigger('done');

        if (res.error == true &&
          res.msg == 'User already exists in this week') {
          $('.form-error').slideDown();
          form.find('input[type="submit"]')
            .prop('disabled', false);
        } else {
          $('.form-error').slideUp();
          form.find('input[type="submit"]')
            .prop('disabled', false);
          changeState(formNext);
        }


      }).fail(function (error) {
        console.error(error)
      });
    }
  }

  stateSubmission.find('form').submit(function (e) {
    e.preventDefault();

    formSubmission($(this), stateReferral, [stateLetter, stateSubmission]);
  });


  stateReferral.find('form').submit(function (e) {
    e.preventDefault();

    formSubmission($(this), stateSuccess, [stateLetter, stateSubmission, stateReferral]);
  });

  $('.comp-navigation-sticky').clone().insertAfter('#influencers-header');
}

const initAccounts = () => {
  // password reset
  const gateWrapper = $('#account-gate-wrapper');
  const gateContent = $('#account-gate');
  const resetPasswordTrigger = $('#reset-password-trigger');
  const resetPasswordCancel = $('#reset-password-cancel');
  const resetPasswordField = $('#account-recover-email');

  resetPasswordTrigger.click(function (e) {
    e.preventDefault();

    html.addClass('reset_form_active');
    history.pushState(null, null, '#recover');

    resetPasswordField.focus();

    gateWrapper.css('min-height', `${$('#account-reset').outerHeight(true)}px`);
  });

  resetPasswordCancel.click(function (e) {
    e.preventDefault();

    html.removeClass('reset_form_active');
    history.pushState(null, null, ' ');

    gateWrapper.css('min-height', `${$('#account-reset').outerHeight(true)}px`);
  });

  (window.location.hash == '#recover')
    ? resetPasswordTrigger.trigger('click') : '';

  gateWrapper.css('min-height', `${$('#account-reset').outerHeight(true)}px`);

  // address management
  const addressAddTrigger = $('#address-add-trigger');

  addressAddTrigger.click(function () {
    html.addClass('address_pop_active');

    $('#address-add').show();
  });
}

const initFields = () => {
  let inputs = $(`.field input[type="text"],
		.field input[type="email"],
		.field input[type="tel"],
		.field input[type="url"],
		.field input[type="password"],
		.field textarea`);
  let select = $('.field select');

  inputs.on('init blur', function () {
    let _this = $(this);

    (_this.val().length > 0)
      ? _this.closest('.field').addClass('has_value')
      : _this.closest('.field').removeClass('has_value');
  });

  siteReadyTrigger(function () {
    inputs.trigger('init');
  });

  select.on('change', function () {
    let _this = $(this);

    _this.closest('.field').addClass('has_value');
  });
}

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

const initCompNavigationSticky = () => {
  const section = $('[data-navigation-section]');
  const navigationScroll = () => {
    let scrollTopOffset = scrollTop + scrollOffset;

    if (isMobile) {
      (scrollTopOffset > $(section[0]).attr('data-navigation-top') &&
        scrollTopOffset < parseInt($(section[section.length - 1]).attr('data-navigation-top')) + (windowHeight * 4))
        ? html.addClass('sticky_navigation_active')
        : html.removeClass('sticky_navigation_active');
    }
    else {
      (scrollTopOffset > $(section[0]).attr('data-navigation-top') &&
        scrollTopOffset < parseInt($(section[section.length - 1]).attr('data-navigation-top')) + (windowHeight * 3))
        ? html.addClass('sticky_navigation_active')
        : html.removeClass('sticky_navigation_active');
    }

    // get all anchor with top offset
    section.each(function (i) {
      let _this = $(this);
      let _thisTop = parseInt(_this.attr('data-navigation-top'));
      let _thisNextTop = $(section[i + 1]).length
        ? parseInt($(section[i + 1]).attr('data-navigation-top'))
        : Infinity

      if (!isMobile) {
        if (i > 2) {
          scrollTopOffset = scrollTopOffset - 200
        }
      }
      else {
        if (i > 2 && i <= 5) {
          scrollTopOffset = scrollTopOffset - 300
        }
        else if (i >= 6) {
          scrollTopOffset = scrollTopOffset - 400
        }
      }

      if (scrollTopOffset > _thisTop &&
        scrollTopOffset < _thisNextTop) {
        $(`.comp-navigation-sticky a[href^="#${_this.attr('id')}"]`)
          .parent().addClass('active')
          .siblings().removeClass('active');
      }
    });
  }

  // creat and prepend navigation HTML
  navigationHtml = '';
  section.each(function () {
    let _this = $(this);

    navigationHtml += `<li>
			<a href="#${_this.attr('id')}">${_this.attr('data-navigation-section')}</a>
		</li>`
  });

  body.append(`<div class="comp-navigation-sticky">
		<ul class="t-link user-select-disable">${navigationHtml}</ul>
	</div>`);

  // register navigation click action
  _document.on('click', '.comp-navigation-sticky a', function (e) {
    e.preventDefault();

    scrollTo($(this).attr('href'));
  });

  // assign scroll top position to each navigation collection
  section.each(function () {
    let _this = $(this);

    siteReadyTrigger(function () {
      _this.attr('data-navigation-top', Math.floor(_this.offset().top));
      navigationScroll();
    });
  });

  // run scroll functions
  _window.scroll(navigationScroll);
}

const initCompNavigationStickySust = () => {
  const section = $('[data-navigation-section]');
  const navigationScroll = () => {
    let scrollTopOffset = scrollTop + scrollOffset;

    if (isMobile) {
      (scrollTopOffset > $(section[0]).attr('data-navigation-top') &&
        scrollTopOffset < parseInt($(section[section.length - 1]).attr('data-navigation-top')) + (windowHeight * 3))
        ? html.addClass('sticky_navigation_active')
        : html.removeClass('sticky_navigation_active');
    }
    else {
      (scrollTopOffset > $(section[0]).attr('data-navigation-top') &&
        scrollTopOffset < parseInt($(section[section.length - 1]).attr('data-navigation-top')) + (windowHeight * 2))
        ? html.addClass('sticky_navigation_active')
        : html.removeClass('sticky_navigation_active');
    }


    // get all anchor with top offset
    section.each(function (i) {
      let _this = $(this);
      let _thisTop = parseInt(_this.attr('data-navigation-top'));
      let _thisNextTop = $(section[i + 1]).length
        ? parseInt($(section[i + 1]).attr('data-navigation-top'))
        : Infinity

      if (!isMobile) {
        if (i > 2) {
          scrollTopOffset = scrollTopOffset - 200
        }
      }
      else {
        if (i > 2 && i <= 5) {
          scrollTopOffset = scrollTopOffset - 300
        }
        else if (i >= 6) {
          scrollTopOffset = scrollTopOffset - 400
        }
      }

      if (scrollTopOffset > _thisTop &&
        scrollTopOffset < _thisNextTop) {
        $(`.comp-navigation-sticky-v2 a[href^="#${_this.attr('id')}"]`)
          .parent().addClass('active')
          .siblings().removeClass('active');
      }
    });
  }

  // creat and prepend navigation HTML
  navigationHtml = '';
  section.each(function () {
    let _this = $(this);

    navigationHtml += `<li>
			<a href="#${_this.attr('id')}">${_this.attr('data-navigation-section')}</a>
		</li>`
  });

  body.append(`<div class="comp-navigation-sticky-v2">
		<ul class="t-link user-select-disable">${navigationHtml}</ul>
	</div>`);

  // register navigation click action
  _document.on('click', '.comp-navigation-sticky-v2 a', function (e) {
    e.preventDefault();

    scrollTo($(this).attr('href'));
  });

  // assign scroll top position to each navigation collection
  section.each(function () {
    let _this = $(this);

    siteReadyTrigger(function () {
      _this.attr('data-navigation-top', Math.floor(_this.offset().top));
      navigationScroll();
    });
  });

  // run scroll functions
  _window.scroll(navigationScroll);
}

const md5 = function (d) { var r = M(V(Y(X(d), 8 * d.length))); return r.toLowerCase() }; function M(d) { for (var _, m = "0123456789ABCDEF", f = "", r = 0; r < d.length; r++)_ = d.charCodeAt(r), f += m.charAt(_ >>> 4 & 15) + m.charAt(15 & _); return f } function X(d) { for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++)_[m] = 0; for (m = 0; m < 8 * d.length; m += 8)_[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32; return _ } function V(d) { for (var _ = "", m = 0; m < 32 * d.length; m += 8)_ += String.fromCharCode(d[m >> 5] >>> m % 32 & 255); return _ } function Y(d, _) { d[_ >> 5] |= 128 << _ % 32, d[14 + (_ + 64 >>> 9 << 4)] = _; for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) { var h = m, t = f, g = r, e = i; f = md5_ii(f = md5_ii(f = md5_ii(f = md5_ii(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_ff(f = md5_ff(f = md5_ff(f = md5_ff(f, r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 0], 7, -680876936), f, r, d[n + 1], 12, -389564586), m, f, d[n + 2], 17, 606105819), i, m, d[n + 3], 22, -1044525330), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 4], 7, -176418897), f, r, d[n + 5], 12, 1200080426), m, f, d[n + 6], 17, -1473231341), i, m, d[n + 7], 22, -45705983), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 8], 7, 1770035416), f, r, d[n + 9], 12, -1958414417), m, f, d[n + 10], 17, -42063), i, m, d[n + 11], 22, -1990404162), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 12], 7, 1804603682), f, r, d[n + 13], 12, -40341101), m, f, d[n + 14], 17, -1502002290), i, m, d[n + 15], 22, 1236535329), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 1], 5, -165796510), f, r, d[n + 6], 9, -1069501632), m, f, d[n + 11], 14, 643717713), i, m, d[n + 0], 20, -373897302), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 5], 5, -701558691), f, r, d[n + 10], 9, 38016083), m, f, d[n + 15], 14, -660478335), i, m, d[n + 4], 20, -405537848), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 9], 5, 568446438), f, r, d[n + 14], 9, -1019803690), m, f, d[n + 3], 14, -187363961), i, m, d[n + 8], 20, 1163531501), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 13], 5, -1444681467), f, r, d[n + 2], 9, -51403784), m, f, d[n + 7], 14, 1735328473), i, m, d[n + 12], 20, -1926607734), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 5], 4, -378558), f, r, d[n + 8], 11, -2022574463), m, f, d[n + 11], 16, 1839030562), i, m, d[n + 14], 23, -35309556), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 1], 4, -1530992060), f, r, d[n + 4], 11, 1272893353), m, f, d[n + 7], 16, -155497632), i, m, d[n + 10], 23, -1094730640), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 13], 4, 681279174), f, r, d[n + 0], 11, -358537222), m, f, d[n + 3], 16, -722521979), i, m, d[n + 6], 23, 76029189), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 9], 4, -640364487), f, r, d[n + 12], 11, -421815835), m, f, d[n + 15], 16, 530742520), i, m, d[n + 2], 23, -995338651), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 0], 6, -198630844), f, r, d[n + 7], 10, 1126891415), m, f, d[n + 14], 15, -1416354905), i, m, d[n + 5], 21, -57434055), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 12], 6, 1700485571), f, r, d[n + 3], 10, -1894986606), m, f, d[n + 10], 15, -1051523), i, m, d[n + 1], 21, -2054922799), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 8], 6, 1873313359), f, r, d[n + 15], 10, -30611744), m, f, d[n + 6], 15, -1560198380), i, m, d[n + 13], 21, 1309151649), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 4], 6, -145523070), f, r, d[n + 11], 10, -1120210379), m, f, d[n + 2], 15, 718787259), i, m, d[n + 9], 21, -343485551), m = safe_add(m, h), f = safe_add(f, t), r = safe_add(r, g), i = safe_add(i, e) } return Array(m, f, r, i) } function md5_cmn(d, _, m, f, r, i) { return safe_add(bit_rol(safe_add(safe_add(_, d), safe_add(f, i)), r), m) } function md5_ff(d, _, m, f, r, i, n) { return md5_cmn(_ & m | ~_ & f, d, _, r, i, n) } function md5_gg(d, _, m, f, r, i, n) { return md5_cmn(_ & f | m & ~f, d, _, r, i, n) } function md5_hh(d, _, m, f, r, i, n) { return md5_cmn(_ ^ m ^ f, d, _, r, i, n) } function md5_ii(d, _, m, f, r, i, n) { return md5_cmn(m ^ (_ | ~f), d, _, r, i, n) } function safe_add(d, _) { var m = (65535 & d) + (65535 & _); return (d >> 16) + (_ >> 16) + (m >> 16) << 16 | 65535 & m } function bit_rol(d, _) { return d << _ | d >>> 32 - _ }


const initCompNewsletter = () => {
  const submitSuccess = (form) => {
    form.addClass('success')
      .find('h2').text('Thanks for subscribing!');

    setTimeout(function () {
      form.find('h2').after(`<p class="newsletter-success">${(form.closest('#newsletter-popup').length)
        ? 'We can’t wait to connect.<br>Check your email for promo your code.'
        : 'You’re now subscribed to our newsletter. You should receive a confirmation email shortly.'
        }</p>`).fadeIn();
    }, 300);
  }

  $('.comp-newsletter').submit(function (e) {
    let _this = $(this);
    let tags = _this.find('[name="contact[tags]"]:checked').val() || null;
    let newsletterEmail = _this.find('input[type="email"]');

    if (!newsletterEmail.val() ||
      !validateEmail(newsletterEmail.val())) {
      e.preventDefault();

      _this.find('.newsletter-email-field, .field')
        .addClass('error');
    } else {
      $.ajax({
        type: 'POST',
        async: true,
        url: _this.attr('action'),
        data: _this.serialize(),
        beforeSend: function () {
          loadingBarTrigger('start');
        },
        error: function (error) {
          console.error(error);

          localStorage.setItem('luNewsletterSubmittedLocation',
            _this.find('[name="location"]').val());

          if (error.status != 429) {
            e.preventDefault();
          }
        },
        success: function (response) {
          e.preventDefault();
          submitSuccess(_this);
        }
      }).always(function () {
        loadingBarTrigger('done');
      });
    }
  });

  let submittedLocation = localStorage.getItem('luNewsletterSubmittedLocation');

  if ((window.location.href.indexOf('?customer_posted=true') != -1 ||
    window.location.href.indexOf('?contact') != -1) &&
    submittedLocation) {
    localStorage.removeItem('luNewsletterSubmittedLocation');

    if (submittedLocation == 'Footer Newsletter') {
      scrollTo('#footer-newsletter');
      submitSuccess($('#footer-newsletter .comp-newsletter'));

    } else if (submittedLocation == 'Footer Connect') {
      scrollTo('#footer');
      submitSuccess($('#footer-connect .comp-newsletter'))

    } else if (submittedLocation == 'Popup') {
      html.addClass('newsletter_popup_active');
      submitSuccess($('#newsletter-popup .comp-newsletter'));
    }
  }
}

const initCompSlider = () => {
  $('.comp-slider').each(function () {
    let slider = $(this);
    let sliderContent = slider.find('.slider-content');

    slider.imagesLoaded(function () {
      if (sliderContent.width() < html.find('.width').width()) {
        slider.addClass('slider-disabled');
        slider.find('.slide-spacer').remove();
      } else {
        if (!slider[0].hasAttribute('data-slider-wraparound') &&
          !screenIsMobile && !slider.parent().hasClass("width") ) {
          sliderContent.append('<div class="slide-spacer"></div>')
            .prepend('<div class="slide-spacer"></div>');
        }
        sliderContent.flickity({
          cellSelector: '[class^="slide-"]',
          cellAlign: slider[0].hasAttribute('data-slider-cellalign')
            ? slider.attr('data-slider-cellalign')
            : slider[0].hasAttribute('data-slider-wraparound')
              ? 'center'
              : (screenIsMobile)
                ? 'center' : 'left',
          wrapAround: slider[0].hasAttribute('data-slider-wraparound')
            ? true : (screenIsMobile)
              ? true : false,
          prevNextButtons: slider[0].hasAttribute('data-slider-arrows')
            ? true : false,
          pageDots: slider[0].hasAttribute('data-slider-dots')
            ? true : false,
          draggable: slider[0].hasAttribute('data-slider-draggable')
            ? true : (screenIsMobile)
              ? true : false,
          freeScroll: (screenIsMobile)
            ? true : false,
          contain: true,
          imagesLoaded: true,
          groupCells: true,
          accessibility: true
        });
      }
    });
  });
}

const initCompSliderTestimonial = () => {
  $('.comp-slider-testimonial').each(function () {
    let testimonial = $(this);
    let testimonialSlider = testimonial.find('.slider-testimonial-content');

    testimonial.imagesLoaded(function () {
      testimonialSlider.flickity({
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: false,
        pageDots: (testimonial.find('.testimonial').length > 1) ? true : false
      }).on('staticClick.flickity', function (e, pointer, el, i) {
        if (typeof i == 'number') {
          testimonialSlider.flickity('select', i);
        }
      });
    });
  });
}

const initCompSliderTopbar = () => {

  $('.comp-slider-topbar').each(function () {
    let topbar = $(this);
    let topbarSlider = topbar.find('.slider-topbar-content');

    topbar.imagesLoaded(function () {
      topbarSlider.flickity({
        cellAlign: 'center',
        fade: true,
        pauseAutoPlayOnHover: false,
        prevNextButtons: false,
        draggable: false,
        autoPlay: 4000,
        pageDots: false
      }).on('staticClick.flickity', function (e, pointer, el, i) {
        if (typeof i == 'number') {
          topbarSlider.flickity('select', i);
        }
      });
      topbarSlider.on('select.flickity', function () {
        topbarSlider.flickity('playPlayer')
      })
    });

  });

}

const initCompImageBreak = () => {
  $('.comp-image-break').each(function () {
    let imageBreak = $(this);
    let imageBreakSlides = imageBreak.find('.image-break-slide');

    if (imageBreakSlides.length > 1) {
      imageBreak.append(`<div class="image-break-paginate width">
				${Array(imageBreakSlides.length).join(0).split(0).map((item, i) => `<button
						data-paginate="${i}"
						aria-label="Paginate to ${i} slide"
						${(i == 0) ? ' class="active"' : ''}></button>
				`).join('')}
			</div>`);
    }

    let imageBreakPagination = imageBreak.find('[data-paginate]');
    let navigateSlides = (direction) => {
      let slideActive = imageBreak.find('[data-paginate].active').index();

      if (direction == 'previous') {
        // if active slide is the first slide
        if (slideActive == 0) {
          // jump to the last slide
          $(imageBreakPagination[imageBreakPagination.length - 1]).trigger('click');
        } else {
          // else, move to previous slide
          $(imageBreakPagination[slideActive - 1]).trigger('click');
        }
      } else if (direction == 'next') {
        // if active slide is the last slide
        if (slideActive + 1 == imageBreakPagination.length) {
          // jump to the first slide
          $(imageBreakPagination[0]).trigger('click');
        } else {
          // else jump to next slide
          $(imageBreakPagination[slideActive + 1]).trigger('click');
        }
      }
    }

    imageBreakPagination.click(function () {
      let _this = $(this);

      _this.addClass('active')
        .siblings().removeClass('active');

      $(imageBreakSlides[_this.data('paginate')]).addClass('active')
        .siblings('.image-break-slide').removeClass('active');
    });

    if (screenIsMobile) {
      xDown = null;

      imageBreak[0].addEventListener('touchstart', handleTouchStart, false)
      imageBreak[0].addEventListener('touchmove', handleTouchMove, false);

      function handleTouchStart(e) {
        firstTouch = (e.touches || e.originalEvent.touches)[0];
        xDown = firstTouch.clientX;
      };

      function handleTouchMove(e) {
        if (!xDown) {
          return;
        }

        var xUp = e.touches[0].clientX;
        var xDiff = xDown - xUp;

        if (xDiff > 5) {
          navigateSlides('next');
        } else if (xDiff < -5) {
          navigateSlides('previous');
        }

        xDown = null;
      };
    }
  });
}

const initCompLightboxVideo = () => {
  $('[data-lightbox-video]').each(function () {
    $(this).appendTo(body);
  });

  const allButtons = document.querySelectorAll("[data-lightbox-video-trigger]");
  allButtons.forEach((child, index) => {
    child.dataset.id = index + 1;

  });

  $('[data-lightbox-video-trigger]').click(function () {

    const idVideo = Number(this.dataset.id);

    const AllIframes = document.querySelectorAll("[data-lightbox-video]");
    AllIframes.forEach((child, index) => {

      if (index + 1 != idVideo) {
        child.style.display = "none";
      } else {
        child.style.display = "flex";
      }

    })


    let lightbox = $(`[data-lightbox-video="${$(this).attr('data-lightbox-video-trigger')}"]`);
    const vimeoIframe = lightbox.find('iframe');
    let vimeoPlayer = null;
    if (vimeoIframe.length > 0) {
      vimeoPlayer = new Vimeo.Player(lightbox.find('iframe')[idVideo - 1]);
    }

    html.addClass('lightbox_video_active');
    lightbox.addClass('active');

    if (vimeoPlayer) {
      vimeoPlayer.ready().then(function () {
        vimeoPlayer.play();
      });
    }

    lightbox.find('.lightbox-close, .lightbox-overlay').click(function () {
      html.removeClass('lightbox_video_active');
      lightbox.removeClass('active');

      if (vimeoPlayer) {
        vimeoPlayer.pause();
      }
    });
  });
}

const initCompShopTheLook = () => {
  $('[data-shop-the-look-trigger]').click(function () {
    let look = $(`[data-shop-the-look="${$(this).attr('data-shop-the-look-trigger')}"]`);
    html.addClass('shop_the_look_active');
    look.addClass('active');

    look.find('.look-close, .look-overlay').click(function () {
      html.removeClass('shop_the_look_active');
      look.removeClass('active');
    });

    const section = $(this).closest('section');
    if (section) {
      const anchor = section.attr('id');
      window.location.hash = anchor;
    }
  });

  $('.shop-the-look').each(function () {
    $(this).find('.js-flickity-mobile')
        .flickity({
          cellAlign: 'center',
          wrapAround: true,
          prevNextButtons: false,
          pageDots: true,
          watchCSS: true
    });
  });
}

const initCompProductCard = () => {
  swatchRevertOriginal = null;
	// swatches-emb
	_document.on('mouseenter', '[data-swatch-image-emb]', function () {
		let _this = $(this);
		let product = _this.closest('.comp-product-card');
		let productBadge = product.find('.product-badge');
		let thumbnailImg = product.find('.product-thumbnail img').length
			? product.find('.product-thumbnail img')
			: $('<img>').prependTo(product.find('.product-thumbnail')).wrap('<span class="object-fit">');

		if (!product.attr('data-badge-original') &&
			product.find('.product-badge.show').length) {
			product.attr('data-badge-original', product.find('.product-badge.show').text());
		}

		if (!product.attr('data-thumbnail-original')) {
			product.attr('data-thumbnail-original', thumbnailImg.attr('src'));
		}

		clearTimeout(swatchRevertOriginal);

		if (_this.attr('data-swatch-badge')) {
			productBadge.addClass('show')
				.text(_this.attr('data-swatch-badge'));
		} else {
			productBadge.removeClass('show')
		}

		thumbnailImg.css('opacity', 0)
			.attr('srcset', '')
			.attr('src', _this.attr('data-swatch-image-emb'))
			.on("load", function () {
				thumbnailImg.css('opacity', 1);
			});
	}).on('mouseleave', '[data-swatch-image-emb]', function () {
		let _this = $(this);
		let product = _this.closest('.comp-product-card');
		let productBadge = product.find('.product-badge');
		let thumbnailImg = product.find('.product-thumbnail img');

		swatchRevertOriginal = setTimeout(function () {
			product.attr('data-badge-original')
				? productBadge.addClass('show')
					.text(product.attr('data-badge-original'))
				: productBadge.removeClass('show');

			thumbnailImg.attr('src', product.attr('data-thumbnail-original'))
				.addClass('css_fadeIn');

			setTimeout(function () {
				thumbnailImg.removeClass('css_fadeIn');
			}, 300);
		}, 300);

		if (_this.hasClass('active')) {
			clearTimeout(swatchRevertOriginal);

			product.attr('data-badge-original', product.find('.product-badge.show').text());

			product.attr('data-thumbnail-original', thumbnailImg.attr('src'));
		}
	}).on('click', '[data-swatch-color-emb]', function () {
		let _this = $(this);
		let product = _this.closest('.comp-product-card');
		let productBadge = product.find('.product-badge');
		let thumbnailImg = product.find('.product-thumbnail img');
		let addToCart = $('#AddToCart-emb');

		addToCart.attr('data-quickadd-id', _this.attr('data-swatch-id'));
		_this.addClass('active')
			.siblings().removeClass('active');

		if (_this.attr('data-swatch-badge')) {
			productBadge.addClass('show')
				.text(_this.attr('data-swatch-badge'));
		}

		if (_this.attr('data-swatch-image')) {
			thumbnailImg.attr('src', _this.attr('data-swatch-image'));
		}

		$(product.find('.product-quickadd ul')[_this.index()]).addClass('active')
			.siblings().removeClass('active');

		product.attr('data-wishlist-variant-id',
			_this.attr('data-swatch-id'));

	});

	// remove empty quickadd ULs
	$('.product-quickadd ul').each(function () {
		(!$(this).find('li').length)
			? $(this).remove() : '';
	});

	// assign active state to the first available quick add ul
	// need this for products without swatches
	$('.product-quickadd ul:first-of-type').addClass('active');

	// trigger first variant image on load
	$('[data-swatch-image].active').click().trigger('mouseenter');
}

const initCompToggle = () => {
  _document.on('click', '.toggle-label', function () {
    $(this).siblings('.toggle-content').slideToggle()
      .closest('.toggle').toggleClass('active')
      .siblings().removeClass('active')
      .find('.toggle-content').slideUp();
  });
}

const initProductImagesPopup = () => {
  const productImagesPopup = $('#product-images-popup');
  const productImagesPopupClose = productImagesPopup.find('#product-images-popup-close');
  const galleryImageFeatured = productImagesPopup.find('#gallery-image-featured');
  const popupOverlay = productImagesPopup.find('#product-images-popup-overlay');

  const productImagesPopupCloseTrigger = (e) => {
    if (!e.target.closest('.splide__arrows')) {
      $('#gallery-images-list ul li.active').removeClass('active');
      $('#gallery-image-featured .thumbnail span.active').removeClass('active');
      html.removeClass('product_images_popup_active');
    }
  }

  // close newsletter on click
  popupOverlay.click(productImagesPopupCloseTrigger);
  // galleryImageFeatured.click(productImagesPopupCloseTrigger);
  productImagesPopupClose.click(productImagesPopupCloseTrigger);
}

const galleryPopupHide = () => {
  const galleryImagesList = $('#gallery-images-list [data-image]');
  const galleryFeaturedImages = $('#gallery-image-featured .image');
  const swatch = $("#product-hero-form .swatch-list button.active");
  const size = $('.variant-banner.active');
  let selectedSize = 'XS'
  if (size.text().trim().includes('LARGE')) {
    selectedSize = '2X'
  } else { selectedSize = 'XS' }
  let label = "";
  if (swatch) {
    label = swatch.attr("aria-label");
  }
  if (label != "") {

    let active = false;
    Array.from(galleryImagesList).forEach(child => {
      child.classList.remove("hidden");
      let fullAlt = child.dataset.imageAlt;
      let imageAlt = child.dataset.imageAlt.split("#");
      if (selectedSize == '2X') {
        if (fullAlt.indexOf(selectedSize) < 0) {
          child.classList.add('hidden');
        } else {
          if (imageAlt[1] == label) {
            if (!active) {
              $(child).addClass("active");
              active = true;
            }
          }
        }
      } else {
        if (fullAlt.indexOf('2X') > -1) {
          child.classList.add('hidden');
        } else {
          if (imageAlt[1] == label) {
            if (!active) {
              $(child).addClass("active");
              active = true;
            }
          }
        }
      }
      if (imageAlt[1] != label) {
        child.classList.add('hidden');
      }
    });

    active = false;

    Array.from(galleryFeaturedImages).forEach(child => {
      child.classList.remove("hidden");
      if (child.children[0].alt != null) {

        let fullAlt = child.children[0].alt;
        let imageAlt = child.children[0].alt.split("#");
        if (selectedSize == '2X') {
          if (fullAlt.indexOf(selectedSize) < 0) {
            child.classList.add('hidden');
          } else {
            if (imageAlt[1] == label) {
              if (!active) {
                $(child).addClass("active");
                active = true;
              }
            }
          }
        } else {
          if (fullAlt.indexOf('2X') > -1) {
            child.classList.add('hidden');
          } else {
            if (imageAlt[1] == label) {
              if (!active) {
                $(child).addClass("active");
                active = true;
              }
            }
          }
        }
        if (imageAlt[1] != label) {
          child.classList.add('hidden');
        }
      }
    });

  }
}
const initImageGallery = () => {
  // images
  const galleryImagesList = $('#gallery-images-list [data-image]');
  const galleryFeaturedImages = $('#gallery-image-featured .image');
  const heroImages = $('#hero-images-featured-interior .image');

  const imageHideBasedOnSize = () => {
    let variantActive = $('.product-variants [data-variant-id].active');

    imageShowIndex = [];
    imageHasSizeIndex = [];



    galleryImagesList.each(function (i) {
      let _this = $(this);

      _this.removeClass('hidden');
      $(galleryFeaturedImages[i]).removeClass('hidden');

      if (imageShowIndex.length) {
        if (!imageShowIndex.includes(i)) {
          _this.addClass('hidden');
          $(galleryFeaturedImages[i]).addClass('hidden');
        }
      } else if (imageHasSizeIndex.includes(i)) {
        _this.addClass('hidden');
        $(galleryFeaturedImages[i]).addClass('hidden');
      }
    });
  }

  galleryImagesList.click(function () {
    let _this = $(this);

    _this.addClass('active')
      .siblings().removeClass('active');

    $(galleryFeaturedImages[_this.attr('data-image')])
      .addClass('active')
      .siblings().removeClass('active');
  });

  initProductImagesPopup();
  galleryPopupHide();
  heroImages.click(function () {
    const _this = $(this);
    const imageId = _this.data('image-id')

    $('#gallery-images-list ul li.active').removeClass('active');
    $('#gallery-images-list ul li[data-image-id="' + imageId + '"]').addClass('active');
    $('#gallery-image-featured .thumbnail span.active').removeClass('active');
    $('#gallery-image-featured .thumbnail span[data-image-id="' + imageId + '"]').addClass('active');

    html.addClass('product_images_popup_active');
  });
}

// 4.0 INIT APP

keyOnPress = false;

_document.on('keydown', function () {
  keyOnPress = true;
}).on('keyup', function () {
  keyOnPress = false;
});

scrollTop = 0;
_window.on('scroll', function () {
  scrollTop = _window.scrollTop();
});

siteReadyTrigger(function () {
  scrollTop = _window.scrollTop();
});

initHeader();
initNewsletterPopup();
initSearchPane();
initSearchIndex();
initCart();

initFields();
initCompNavigationSticky();
initCompNavigationStickySust();
initCompNewsletter();
initCompSlider();
initCompSliderTestimonial();
initCompImageBreak();
initCompLightboxVideo();
initCompShopTheLook();
initCompProductCard();
initCompToggle();
initCompAppointmentEmbed();

window.onload = function () {
  initCompSliderTopbar();
}

switch (html.attr('id')) {
  case 'frontpage':
    initFrontpage();
    break;

  case 'product-index':
    initProductIndex();
    break;

  case 'product-single':
    initProductSingle();
    break;

  case 'blog-index':
    initBlogIndex();
    break;

  case 'blog-single':
    initBlogSingle();
    initLocationsSingle();
    break;

  case 'page-careers':
    initCareers();
    break;

  case 'page-customer-service':
    initCx();
    break;

  case 'page-fabric-care':
    initFabricCare();
    break;

  case 'page-fabric-care-1':
    initFabricCare();
    break;

  case 'page-valentines-day':
    initValentinesDay();
    break;

  case 'page-self-love-letter-giveaway':
    initValentinesDay();
    break;

  case 'accounts':
    initAccounts();
    break;

  case 'page-account-member':
    initAccounts();
    break;
}

initPageTransition();
initPageAnimation();

// RESIZING REFRESH PAGE
/*  _window.on('resize', function() {
  if ((!screenisCompact && _window.width() < 1200) ||
    (screenisCompact && _window.width() >= 1200) ||
    (!screenIsTablet && _window.width() < 900) ||
    (screenIsTablet && _window.width() >= 900) ||
    (!screenIsMobile && _window.width() < 600) ||
    (screenIsMobile && _window.width() >= 600)) {
    body.hide();
    this.location.href = this.location.href;
  }
});
 */

if (window.location.hash == '#contact_form') {
  // scrollTo(0);
  history.replaceState(null, null, ' ');
} else if (window.location.hash &&
  $(window.location.hash).length) {
  scrollTo(window.location.hash);
  history.replaceState(null, null, ' ');
}

// swiping fix for IOS
(function () {
  var touchingCarousel = false,
    touchStartCoords;

  document.body.addEventListener('touchstart', function (e) {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    }
  });

  document.body.addEventListener('touchmove', function (e) {
    if (!(touchingCarousel && e.cancelable)) {
      return;
    }

    var moveVector = {
      x: e.touches[0].pageX - touchStartCoords.x,
      y: e.touches[0].pageY - touchStartCoords.y
    };

    if (Math.abs(moveVector.x) > 7)
      e.preventDefault()

  }, { passive: false });
})();

$('[data-scroll-to]').click(function () {
  scrollTo($(this).attr('data-scroll-to'));
});

$('.video').fitVids();


window.__rmcp2 = JSON.parse(localStorage.getItem('rmcp2Cookie'));
window.__rmuspc = "YN";

jQuery.loadScript = function (url, callback) {
  jQuery.ajax({
    url: url,
    dataType: 'script',
    success: callback,
    async: true
  });
}

const initCompMiniCart = () => {
}

function getProductInfo(handle) {
  return new Promise(function (resolve, reject) {
    jQuery.getJSON('/products/' + handle + '.js', function (product) {
      resolve(product);
    });
  });
}

let imageTabs = $('.variant-banner');
const variantsBtns = $('.product-variants button.t-link');
let imageTabsMobile = $('.variant-banner-mobile');
if (imageTabs) {
  imageTabs.each(function () {
    // assign active states
    $(this).click(function () {
      var txt = $(this).text().trim().toUpperCase().replaceAll("-","").replaceAll("EXTRA","X").replaceAll("SMALL","S").replaceAll("MEDIUM","M").replaceAll("LARGE","L").replaceAll("SIZE ","");
      if(txt.includes("1X")){txt="1X";}else if(txt.includes("2X")){txt="2X";}
      $("#product-hero-form .product-variants button.size-btn[data-size-value='"+txt+"']")[0].click();
      $(this).addClass('active').siblings().removeClass('active');
    })
  })


  if (imageTabsMobile) {
    imageTabsMobile.each(function () {
      // assign active states
      $(this).click(function () {
        $(this).addClass('active').siblings().removeClass('active');
        if ($(this).html().toLowerCase().includes('x-large')) {
          variantsBtns.each(function () {
            if ($(this).html().includes('1X') || $(this).html().includes('2X') || $(this).html().includes('3X')) {
              $(this).click();
              return false;
            }
          })
        } else {
          variantsBtns.each(function () {
            if ($(this).html().includes('XS') || $(this).html().includes('S') || $(this).html().includes('M')) {
              $(this).click();
              return false;
            }
          })
        }
      })
    })
  }

  // WAIT LIST COLLECTION
	function initWaitlistvalues(product) {
		const waitlist = $('#collection-waitlist');
		let waitlistVariantId = waitlist.find('[name="waitlist-variant-id"]');
		let waitlistProductId = waitlist.find('[name="waitlist-product-id"]');
		let waitlistVariantSize = $("#collection-waitlist-variant-size");
		let waitlistProductName = $("#collection-waitlist-product-name");
		let sizeValue = product.attr('data-quickadd-product-size');
		let correctSize = sizeValue;

		switch (sizeValue) {
			case 'XS':
				correctSize = "Extra Small"
				break;
			case 'XS/S':
				correctSize = "Extra Small/Small"
				break;
			case 'XS/S/M':
				correctSize = "Extra Small/Small/Medium"
				break;
			case 'S':
				correctSize = "Small"
				break;
			case 'S/M':
				correctSize = "Small/Medium"
				break;
			case 'M':
				correctSize = "Medium"
				break;
			case 'M/L':
				correctSize = "Medium/Large"
				break;
			case 'L':
				correctSize = "Large"
				break;
			case 'L/XL':
				correctSize = "Large/Extra Large"
				break;
			case 'XL':
			case '1X':
				correctSize = "Extra Large 1"
				break;
			case 'XL2':
			case '2X':
				correctSize = "Extra Large 2"
				break;
			case 'XL3':
				correctSize = "Extra Large 3"
				break;
			case 'XL2/XL3':
				correctSize = "Extra Large 2/3"
				break;
			case 'XXL':
				correctSize = "Extra(x2) Large "
				break;
			case 'OSmall':
				correctSize = "One Size"
				break;
			case 'OS':
				correctSize = "One Size"
				break;
			default:
				break;
		}

    waitlistProductId.val(product.attr('data-quickadd-product-id'))
    waitlistVariantId.val(product.attr('data-quickadd-id'))
    waitlistVariantSize[0].innerHTML = correctSize;
    waitlistProductName[0].innerHTML = product.attr('data-quickadd-product-name')
  }
}

const initProductSingleEmb = () => {
  // images
  const heroImagesListImage = $('#hero-images-list-emb [data-image]');
  const heroImagesFeaturedImages = $('#hero-images-featured-emb .image');
  const embImages = $('.product-hero-images-emb')
  if (screenIsTablet) {
    embImages.insertAfter($('#emb-title'))
  }

  const imageHideBasedOnSize = () => {
    let variantActive = $('.product-variants [data-variant-id].active');
    imageShowIndex = [];
    imageHasSizeIndex = [];

    heroImagesListImage.each(function (i) {
      let alt = $(this).attr('data-image-alt');
      let altSize = alt.substring(
        alt.lastIndexOf(':') + 1,
        alt.lastIndexOf('@')).split(',');

      if (altSize[0] && !altSize[0].includes('iframe')) {
        imageHasSizeIndex.push(i);

        if (altSize.includes(variantActive.text().trim())) {
          imageShowIndex.push(i);
        }
      }
    });

    heroImagesListImage.each(function (i) {
      let _this = $(this);

      _this.removeClass('hidden');
      $(heroImagesFeaturedImages[i]).removeClass('hidden');

      if (imageShowIndex.length) {
        if (!imageShowIndex.includes(i)) {
          _this.addClass('hidden');
          $(heroImagesFeaturedImages[i]).addClass('hidden');
        }
      } else if (imageHasSizeIndex.includes(i)) {
        _this.addClass('hidden');
        $(heroImagesFeaturedImages[i]).addClass('hidden');
      }
    });

    $('#hero-images-list-emb [data-image]:not(.hidden)').first().click();

    if (screenIsTablet) {
      let heroImagesFeaturedInterior = $('#hero-images-featured-interior-emb');

      if (heroImagesFeaturedInterior.hasClass('flickity-enabled')) {
        heroImagesFeaturedInterior.flickity('destroy');
      }

      heroImagesFeaturedInterior.flickity({
        cellAlign: 'center',
        cellSelector: '.image:not(.hidden)',
        wrapAround: false,
        prevNextButtons: true,
        pageDots: false,
        draggable: true,
        freeScroll: true
      });
    }
  }


  const imageZoomTrigger = () => {
    if (screenIsTablet) {
      let toggleSliderDraggability = () => {
        let flickityData = $('#hero-images-featured-interior-emb').data('flickity');

        flickityData.options.draggable = !flickityData.options.draggable;
        flickityData.updateDraggable();
      }

      html.on('touchstart', function (e) {
        imageTouchStart = setTimeout(function () {
          $('#hero-images-featured-emb .image').zoom({
            on: 'click',
            duration: 200,
            touch: true
          });
        }, 10);
      }).on('touchend', function () {
        clearTimeout(imageTouchStart);

        $('#hero-images-featured-emb .image').each(function () {
          let _this = $(this);
          if (_this.find('[role="presentation"]').length) {
            _this.trigger('zoom.destroy');
          }
        });
      });
    } else {
      $('#hero-images-featured-emb .image.active').zoom({
        on: 'click',
        duration: 200,
        magnify: 1.2,
        touch: false,
      });
    }
  }

  heroImagesListImage.click(function () {
    let _this = $(this);

    _this.addClass('active')
      .siblings().removeClass('active');

    $(heroImagesFeaturedImages[_this.attr('data-image')])
      .addClass('active')
      .siblings().removeClass('active');

    imageZoomTrigger();
  });

  if (screenIsTablet) {
    $('#hero-images-featured-interior-emb').removeClass('thumbnail');

    $('#hero-images-list-emb').remove();
  }

  imageHideBasedOnSize();
  imageZoomTrigger();

}

initProductSingleEmb()
//refresh yotpo on window resize:
window.innerWidthOld = window.innerWidth
function refreshYotpo(){
    if (window.innerWidthOld != window.innerWidth) {
      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();
      window.innerWidthOld = window.innerWidth
    }
}
var cleared;
window.addEventListener('resize',function(){
  clearTimeout(cleared);
  cleared = setTimeout(refreshYotpo, 250);
})

document.addEventListener('DOMContentLoaded', () => {
  // Init Plp Carousel
  [...document.querySelectorAll('[data-plp-hero-carousel]')].forEach((element) => {
    const settings = {
      // configure Swiper to use modules
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      centerInsufficientSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 10,
    };
    if (element.classList.contains('plp-hero-carousel--large')) {
      settings.spaceBetween = 20;
    }
    const swiper = new Swiper(element, settings)
  })
});
